
/* eslint react/no-direct-mutation-state: "off",'jsx-a11y/alt-text': 'off','no-redeclare': 'off','no-useless-concat':'off','no-dupe-keys':'off',eqeqeq: 'off'  */

import React, { Component } from 'react';
import { connect } from "react-redux";
import { Col, Button, FormGroup, Label, Form, Modal, Table } from 'reactstrap';
import { CheckBoxSelection, Inject, MultiSelectComponent } from '@syncfusion/ej2-react-dropdowns';
import SearchableEquipmentDropDown from './SearchableDropdown';
import ReactDOM from 'react-dom';
import { Redirect } from 'react-router-dom';
import { FaRegCalendarAlt, FaClock } from 'react-icons/fa';
import { IoMdClose } from 'react-icons/io';
import DatePicker from 'react-datepicker';
import { FaPencilAlt as Edit } from 'react-icons/fa';
import "react-datepicker/dist/react-datepicker.css";
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import classnames from 'classnames';
import moment from 'moment';
import { Icon } from 'semantic-ui-react';
import DeleteIcon from '../../../../Assets/images/Icons__trash2.svg';
import { GetWorkOrderBuildingsList, GetPMBuildingsEquipments, DeleteAttachment, GetWorkorderTechnician, SavePreventativeMaintenance, GetFamilyTypesBySiteId, GetEquipmentsByFamilyType, GetBuildingPoints, GetBuildingEquipmentPoints, GetUsageFamilyTypesBySiteId, GetUsageEquipmentsByFamilyType, GetServerTime, GetWorkOrderEquipments, GetPreventativeMaintenanceCustomFields, GetPreventativeMaintenanceTemplates, SaveAttachmentToFolder, SaveAsAttachment, OpenAddTemplatePopup } from '../../../../action/workorderAction';
import { setAmplitudeEvent } from 'amplitude/amplitude';
import CreatePMTemplate from '../_ModalsForms/CreatePreventativeMaintenanceTemplate';
import '../../../../Assets/EnsembleStyles/TraneConnectGrid.css';
const ErrorSign = {
    color: '#D42D27',
    paddingLeft: '8px',
    paddingTop: '0px',
    paddingRight: '14px',
    width: '22px',
    height: '22px',
    top: '406px',
    left: '959px'
};

class CreatePreventativeMaintenance extends Component {

    componentWillMount() {
        this.props.GetWorkOrderBuildingsList();
        this.props.GetPMBuildingsEquipments(0);
        this.props.GetWorkOrderEquipments();
        this.props.GetServerTime();
        this.props.GetPMCustomFields();
        this.props.GetPreventativeMaintenanceTemplates();
        
        if (this.props.ForEquipment && this.props.getWorkOrderBuildings != undefined) {

            var Equipment_Name = this.props.AlarmInfo[0].EquipmentName;
            var Equipment_FamilyType = this.props.AlarmInfo[0].FamilyType;

            if (this.props.getWorkOrderBuildings.filter(x => x.siteId == this.props.AlarmInfo[0].ActualSiteId && x.isDeleted == false).length > 0) {
                var l_BuildingId = this.props.AlarmInfo[0].SiteId;
                var l_BuildingName = this.props.AlarmInfo[0].SiteName;
                const actionResponse = this.props.GetFamilyTypesBySiteId(l_BuildingId);
                actionResponse.then((result) => {
                    if (this.props.getFamilyTypes !== undefined && this.props.getFamilyTypes !== null && this.props.getFamilyTypes.length) {
                        this.setState({ FamilyTypes: this.props.getFamilyTypes });
                        if (!this.state.HasUsageFamilyChanged && this.props.AlarmInfo[0].ActualSiteId !== 0) {
                            const actionResponse1 = this.props.GetUsageFamilyTypesBySiteId(this.props.AlarmInfo[0].ActualSiteId);
                            actionResponse1.then((result) => {
                                if (this.props.getUsageFamilyTypes !== undefined && this.props.getUsageFamilyTypes !== null && this.props.getUsageFamilyTypes.length) {
                                    var l_FamilyTypeName = this.props.getUsageFamilyTypes.filter(x => x.familyId == Equipment_FamilyType)[0].familyName;
                                    this.setState({ UsageFamilyTypes: this.props.getUsageFamilyTypes, FamilyText: l_FamilyTypeName, FamilyTypeName: l_FamilyTypeName });
                                }
                            })
                        }
                    }
                })

                var date = this.props.getWorkOrderBuildings.filter(x => x.siteId == this.props.AlarmInfo[0].ActualSiteId && x.isDeleted == false)[0].buildingDate;
                let utcOffsetMinute = moment().utcOffset();
                var l_BuildingDate;
                if (utcOffsetMinute >= 0) {
                    l_BuildingDate = moment(moment.parseZone(date).format("YYYY-MM-DD")).add(utcOffsetMinute, 'minutes')
                }
                else {
                    l_BuildingDate = moment(moment.parseZone(date).format("YYYY-MM-DD")).subtract(utcOffsetMinute, 'minutes')
                }

                const actionResponse2 = this.props.GetEquipmentsByFamilyType(l_BuildingId, Equipment_FamilyType);
                actionResponse2.then((result) => {
                    if (this.props.getEquipmentsByFamily !== undefined && this.props.getEquipmentsByFamily !== null && this.props.getEquipmentsByFamily.length) {
                        var l_Equipmentdata = [];
                        this.props.getEquipmentsByFamily.forEach(element => {
                            var Equiplineitem = {
                                "Id": element.objectId,
                                "Name": element.objectName,
                                "Location": this.state.BuildingName,
                                "SubId": element.familyType == '100' ? 1 : 0,
                            }
                            l_Equipmentdata.push(Equiplineitem);
                        });
                        this.setState({ EquipmentData: l_Equipmentdata });
                        if (!this.state.HasEquipmentChanged && Equipment_FamilyType !== '100')
                            this.setState({ UsageEquipments: this.props.getEquipmentsByFamily });
                    }
                })

                const actionResponse3 = this.props.GetBuildingEquipmentPoints(l_BuildingId, this.props.AlarmInfo[0].EquipmentId);
                actionResponse3.then((result) => {
                    if (this.props.getBuildingEquipmentPoints !== undefined && this.props.getBuildingEquipmentPoints !== null && this.props.getBuildingEquipmentPoints.length) {
                        this.setState({ UsageBuildingPoints: this.props.getBuildingEquipmentPoints });
                    }
                })

                this.setState({ BuildingId: l_BuildingId, BuildingName: l_BuildingName, SelectedBuildingDate: l_BuildingDate, UsageBuildingId: l_BuildingId, UsageBuildingName: l_BuildingName, FamilyTypeId: Equipment_FamilyType, UsageFamilyTypeId: Equipment_FamilyType, EquipmentId: this.props.AlarmInfo[0].EquipmentId, EquipmentName: Equipment_Name, EquipmentText: Equipment_Name, UsageEquipmentId: this.props.AlarmInfo[0].EquipmentId });
            }
            else {
                this.setState({ EquipmentId: this.props.AlarmInfo[0].EquipmentId, EquipmentName: Equipment_Name });
            }
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            redirectHome: false,
            IsClickSave: false,
            image_Array: [],
            StatusId: 0,
            UserId: 0,
            BuildingId: 0,
            SelectedBuildingDate: '',
            ServerDate: '',
            BuildingName: '',
            EquipmentId: 0,
            IsNonDiscoveredEquipment: 0,
            EquipmentName: '',
            EquipmentData: [],
            EquipmentLocation: '',
            LogicalBuildingId: 0,
            EquipmentDropDownStyles: {
                position: 'fixed',
                top: 0,
                left: 0,
                zIndex: "9999",
                width: "400px",
                maxHeight: "300px",
                overflowY: "auto",
                zIndex: "9999",
                border: "1px solid black",
                backgroundColor: "white",
                display: "none",
                "overscroll-behavior-y": "contain"  // works in Firefox
            },
            open: false,
            Schedulemodal: false,
            RecurrenceDueDate: '',
            RepeatEvery: 0,
            RepeatInterval: 1,
            DueDateError: false,
            RepeatEveryError: false,
            ScheduleType: 0,
            IsError: false,
            displayImageError: false,
            errorImageName: null,
            errorImageText: " file type not supported",
            error: {
                status: false,
                assigneddto: false,
                name: false,
                building: false,
                equipment: false,
                schedule: false,
                description: false,
                estimate: false,
                parts: false,
                tasklist: false,
                familytype: false,
                customname: false,
                notifyOthers: false
            },
            UsageError: {
                building: false,
                Family: false,
                Equipment: false,
                Point: false,
                limit: false
            },
            FamilyTypes: [],
            FamilyTypeId: 0,
            HasUsageBuildingChanged: false,
            UsageBuildingId: 0,
            UsageBuildingName: '',
            HasUsageFamilyChanged: false,
            UsageFamilyTypes: [],
            UsageFamilyTypeId: 0,
            HasEquipmentChanged: false,
            UsageEquipments: [],
            UsageEquipmentId: 0,
            UsageBuildingPoints: [],
            UsagePointId: 0,
            PointDetails: [],
            UnitName: '',
            LimitValue: 0,
            SchduleTypeText: '',
            FamilyText: '',
            FamilyTypeName: '',
            EquipmentText: '',
            PointText: '',
            ScheduleTypeRdl: 0,
            SchduleTypeTextRdl: '',
            showScheduleText: false,
            LastSavedScheduleDts: {
                RecurrenceDueDate: '',
                RepeatEvery: 0,
                RepeatInterval: 1,
                UsageBuildingId: 0,
                UsageFamilyTypeId: 0,
                UsageEquipmentId: 0,
                UsagePointId: 0,
                UnitName: '',
                LimitValue: 0
            },
            HasEmailAddress: false,
            TemplateID: '0',
            Description: '',
            EstimatedTime: '',
            PartsTools: '',
            Tasks: [],
            TaskName: '',
            IsTaskChecked: false,
            IsTemplateCreateScreen: false,
            PmName: '',
            CustomFieldCollection: [],
            NotifyChecked: false,
            Taskid: 1,
            SelectedNotifyOthersIds:[],
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleMouseScroll = this.handleMouseScroll.bind(this);
        this.preventScrollPropagation = this.preventScrollPropagation.bind(this);
        this.setEquipment = this.setEquipment.bind(this);
        this.setEquipmentWrapperRef = this.setEquipmentWrapperRef.bind(this);
        this.ComputeEquipmentStyle = this.ComputeEquipmentStyle.bind(this);
        this.LoadBuildingEquipment = this.LoadBuildingEquipment.bind(this);
        this.OnStatusChange = this.OnStatusChange.bind(this);
        this.OnUserChange = this.OnUserChange.bind(this);
        this.DeleteAttachment = this.DeleteAttachment.bind(this);
        this.OnSavePreventativeMaintenance = this.OnSavePreventativeMaintenance.bind(this);
        this.OnCancel = this.OnCancel.bind(this);
        this.Scheduletoggle = this.Scheduletoggle.bind(this);
        this.OnSaveRecurrencePattern = this.OnSaveRecurrencePattern.bind(this);
        this.OnCancelRecurrencePattern = this.OnCancelRecurrencePattern.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.OnIntervalChange = this.OnIntervalChange.bind(this);
        this.OnSort = this.OnSort.bind(this);
        this.ScheduleTypeChange = this.ScheduleTypeChange.bind(this);
        this.LoadBuildingEquipmentFromFamilyType = this.LoadBuildingEquipmentFromFamilyType.bind(this);
        this.OnUsageBuildingChange = this.OnUsageBuildingChange.bind(this);
        this.OnUsageFamilyTypeChange = this.OnUsageFamilyTypeChange.bind(this);
        this.OnUsageEquipmentChange = this.OnUsageEquipmentChange.bind(this);
        this.OnUsagePointsChange = this.OnUsagePointsChange.bind(this);
        this.keyPressed = this.keyPressed.bind(this);
        this.OnTemplateChange = this.OnTemplateChange.bind(this);
        this.OnCreateTemplate = this.OnCreateTemplate.bind(this);
        this.dropdown_fields = { text: 'value', value: 'id' };
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        document.addEventListener('wheel', this.handleMouseScroll);
        document.addEventListener('mousewheel', this.preventScrollPropagation); //Works in IE and Chrome
    }

    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps && nextProps.AddTemplateModal !== undefined && nextProps.AddTemplateModal.modal_open !== undefined) {
            this.setState({ IsTemplateCreateScreen: nextProps.AddTemplateModal.modal_open });
            if (this.refs.name_in_input !== undefined)
                this.refs.name_in_input.value = this.state.PmName;
            if(this.props.AddTemplateModal !== undefined){
                if(this.props.AddTemplateModal.modal_open !== nextProps.AddTemplateModal.modal_open){
                    /*Scroll to top of the page*/
                    var scrollPageTop = this.props.Premise ? document.getElementsByClassName('Ensemble_Content_FullPage') : document.getElementsByClassName('Ensemble_Content');
                    if(scrollPageTop[0] !== undefined){
                        this.props.Premise ? scrollPageTop[0].scrollIntoView() : scrollPageTop[0].scrollTop = 0;
                    } 
                }
            }
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        document.removeEventListener('wheel', this.handleMouseScroll);
        document.removeEventListener('mousewheel', this.preventScrollPropagation); //Works in IE and Chrome
    }

    handleClickOutside(event) {
        if (this.equipWrapperRef && !this.equipWrapperRef.contains(event.target) && !this.state.open) {
            let EStateChange = { ...this.state.EquipmentDropDownStyles };
            EStateChange.display = "none";
            this.setState({ EquipmentDropDownStyles: EStateChange });
        }
    }

    handleMouseScroll(event) {
        this.setState({ open: false });
        if (this.equipWrapperRef && !this.equipWrapperRef.contains(event.target)) {
            let EStateChange = { ...this.state.EquipmentDropDownStyles };
            EStateChange.display = "none";
            this.setState({ EquipmentDropDownStyles: EStateChange });
        }
    }

    preventScrollPropagation(event) {
        if (this.equipWrapperRef && this.equipWrapperRef.contains(event.target)) {
            var scrollDown = event.wheelDelta < 0;
            if (scrollDown) {
                var isAtBottom = this.equipWrapperRef.scrollTop + this.equipWrapperRef.clientHeight == this.equipWrapperRef.scrollHeight;
                if (isAtBottom) {
                    event.preventDefault();
                }
            }
            else {
                var isAtTop = this.equipWrapperRef.scrollTop === 0;
                if (isAtTop) {
                    event.preventDefault();
                }
            }
        }
    }

    setOpen = ({ open }) => {
        this.setState({ open: true });
    };

    setClose = ({ open }) => {
        this.setState({ open: false });
    };

    setEquipmentWrapperRef(node) {
        this.equipWrapperRef = node;
    }

    setEquipment(id, name, location, isNonDiscovered){
        var logicalBuildingId;
        if(this.state.BuildingId === 0){
            var FilterValue = this.props.getBuildingEquipments.filter(e => e.siteName === location);
            if(FilterValue[0] !== undefined && FilterValue[0] !== null)
                logicalBuildingId = this.props.getBuildingEquipments.filter(e => e.siteName === location)[0].siteId;
            else
                logicalBuildingId = 0;
        }else{
            logicalBuildingId = 0;
        }      
        let StateChange = { ...this.state.EquipmentDropDownStyles };
        StateChange.display = "none";

        if (id === '') {
            this.setState({
                EquipmentId: 0,
                EquipmentName: name,
                IsNonDiscoveredEquipment: isNonDiscovered,
                EquipmentDropDownStyles: StateChange,
                EquipmentText: name,
                EquipmentLocation: location,
                LogicalBuildingId: 0,
            });
        } else {
            this.setState({
                EquipmentId: id,
                EquipmentName: name,
                IsNonDiscoveredEquipment: isNonDiscovered,
                EquipmentDropDownStyles: StateChange,
                EquipmentText: name,
                EquipmentLocation: location,
                LogicalBuildingId: logicalBuildingId,
            });
        }

        if (!this.state.HasEquipmentChanged) {
            var actualSiteId = 0;
            if (this.props.getWorkOrderBuildings !== undefined && this.props.getWorkOrderBuildings.length > 0 && this.state.BuildingId > 0) {
                var l_MappedSite = this.props.getWorkOrderBuildings.filter(x => x.id == this.state.BuildingId);
                if (l_MappedSite !== undefined && l_MappedSite.length > 0) {
                    actualSiteId = l_MappedSite[0].siteId;
                }
            }
            if (actualSiteId != 0 && this.state.FamilyTypeId != '100') {
                var EquipID = id === '' ? 0 : id;
                this.setState({ UsageEquipmentId: EquipID });
                if (EquipID !== 0) {
                    const actionResponse = this.props.GetBuildingEquipmentPoints(actualSiteId, EquipID);
                    actionResponse.then((result) => {
                        if (this.props.getBuildingEquipmentPoints !== undefined && this.props.getBuildingEquipmentPoints !== null && this.props.getBuildingEquipmentPoints.length) {
                            this.setState({ UsageBuildingPoints: this.props.getBuildingEquipmentPoints });
                        }
                    })
                }
            }
        }
    }

    ComputeEquipmentStyle() {
        var offset = ReactDOM.findDOMNode(this.refs.equipments_in_Select_input).getBoundingClientRect();
        let StateChange = { ...this.state.EquipmentDropDownStyles };
        StateChange.display = "block";
        StateChange.top = parseInt(offset.top) + parseInt(offset.height) + 1;
        StateChange.left = parseInt(offset.left);
        this.setState({ EquipmentDropDownStyles: StateChange });
    }

    OnSort(values) {
        const sorted_data = values.sort((a, b) => {
            let nameA, nameB;
            nameA = a.orderId;
            nameB = b.orderId;
            return (nameA - nameB);
        });
        return sorted_data;
    }

    LoadBuildingEquipment() {
        this.setState({ FamilyTypes: [] });
        var selectedOption = this.refs.buildings_in_Select_input.options.selectedIndex;
        var selectedSiteId = this.refs.buildings_in_Select_input.options[selectedOption].id;
        var actualSiteId = 0;
        if (this.props.getWorkOrderBuildings !== undefined && this.props.getWorkOrderBuildings.length > 0 &&
            selectedSiteId > 0) {
            var l_MappedSite = this.props.getWorkOrderBuildings.filter(x => x.id == selectedSiteId);
            if (l_MappedSite !== undefined && l_MappedSite.length > 0) {
                actualSiteId = l_MappedSite[0].siteId;
            }
        }
        if (selectedSiteId !== '0') {
            const actionResponse = this.props.GetFamilyTypesBySiteId(selectedSiteId);
            actionResponse.then((result) => {
                if (this.props.getFamilyTypes !== undefined && this.props.getFamilyTypes !== null && this.props.getFamilyTypes.length) {
                    this.setState({ FamilyTypes: this.props.getFamilyTypes });
                    if (!this.state.HasUsageFamilyChanged && actualSiteId !== 0) {
                        const actionResponse = this.props.GetUsageFamilyTypesBySiteId(actualSiteId);
                        actionResponse.then((result) => {
                            if (this.props.getUsageFamilyTypes !== undefined && this.props.getUsageFamilyTypes !== null && this.props.getUsageFamilyTypes.length) {
                                this.setState({ UsageFamilyTypes: this.props.getUsageFamilyTypes });
                            }
                        })
                    }
                }
            })
        }

        var l_SelectedBuilding = this.props.getBuildingEquipments.filter(el => el.siteId == actualSiteId);
        var l_Equipmentdata = []

        if (l_SelectedBuilding !== undefined && l_SelectedBuilding !== null && l_SelectedBuilding.length > 0) {
            var Equiplineitem = '';
            l_SelectedBuilding.forEach(building => {
                if (building.equipment !== undefined && building.equipment !== null && building.equipment.length > 0) {
                    let siteName = building.siteName;
                    building.equipment.forEach(element => {
                        Equiplineitem = {
                            "Id": element.objectId,
                            "Name": element.objectName,
                            "Location": siteName,
                            "SubId": 0,
                        }
                        l_Equipmentdata.push(Equiplineitem);
                    });
                }
            });
        };
        if (selectedSiteId !== '0') {
            var l_SelectedBuildingEquipment = this.props.getEquipments.filter(el => el.siteId == selectedSiteId)
            if (l_SelectedBuildingEquipment !== undefined && l_SelectedBuildingEquipment !== null && l_SelectedBuildingEquipment.length > 0) {
                var Equiplineitem = '';
                l_SelectedBuildingEquipment.forEach(Equipment => {
                    Equiplineitem = {
                        "Id": Equipment.id,
                        "Name": Equipment.name,
                        "Location": Equipment.buildingName,
                        "SubId": 1,
                    }
                    l_Equipmentdata.push(Equiplineitem);
                });
            }
        }

        var date = this.refs.buildings_in_Select_input.options[selectedOption].getAttribute('data-buildingDate')
        let utcOffsetMinute = moment().utcOffset();
        var l_BuildingDate;
        if (utcOffsetMinute >= 0) {
            l_BuildingDate = moment(moment.parseZone(date).format("YYYY-MM-DD")).add(utcOffsetMinute, 'minutes')
            //l_ServerTime = moment(moment.parseZone(l_ServerTime).format("YYYY-MM-DD")).add(utcOffsetMinute, 'minutes')
        }
        else {
            l_BuildingDate = moment(moment.parseZone(date).format("YYYY-MM-DD")).subtract(utcOffsetMinute, 'minutes')
            //l_ServerTime = moment(moment.parseZone(l_ServerTime).format("YYYY-MM-DD")).subtract(utcOffsetMinute, 'minutes')
        }


        this.setState({
            BuildingId: this.refs.buildings_in_Select_input.options[selectedOption].id,
            BuildingName: this.refs.buildings_in_Select_input.options[selectedOption].value,
            SelectedBuildingDate: l_BuildingDate,
            FamilyTypeId: 0,
            EquipmentId: 0,
            EquipmentName: '',
            EquipmentData: l_Equipmentdata
        });
        if (!this.state.HasUsageBuildingChanged)
            this.setState({ UsageBuildingId: this.refs.buildings_in_Select_input.options[selectedOption].id, UsageBuildingName: this.refs.buildings_in_Select_input.options[selectedOption].value });

        if (selectedSiteId !== '0')
            this.refs.buildings_in_Select_input.style.color = '#000000';
        else
            this.refs.buildings_in_Select_input.style.color = '#999999';
    }

    keyPressed(event) {
        var code = event.keyCode || event.which;
        if (code === 13) {
            let value = event.target.value;
            let i = this.state.Taskid;
            if (value !== '') {
                //dynamically creating checkboxes
                var checkbox = document.createElement('input');
                checkbox.setAttribute('type', 'checkbox');
                checkbox.setAttribute('id', 'check' + i);
                checkbox.style.verticalAlign = "middle";

                //dynamically creating input 
                var input = document.createElement('input');
                input.setAttribute('type', 'text');
                input.setAttribute('id', 'task' + i);
                input.style.backgroundColor = "rgb(244,244,244)";
                input.style.border = "none";
                input.style.verticalAlign = "middle";
                input.style.width = this.props.ForEquipment ? '90%' : "95%";
                input.className = "text_field_css";
                input.setAttribute('autofocus', 'true');
                input.addEventListener('keyup', this.keyPressed);

                //dynamically creating span
                var span = document.createElement('span');
                span.setAttribute('contenteditable', 'false');
                span.appendChild(checkbox);

                //dynamically creating td,tr
                var td = document.createElement('td');
                td.className = "col-sm-12";
                td.style.padding = "0px";
                td.appendChild(span);
                td.appendChild(document.createTextNode('\u00A0'));
                td.appendChild(input);

                var tr = document.createElement('tr');
                tr.appendChild(td);

                document.getElementById("taskid").appendChild(tr);
                document.getElementById('task' + i).focus();
                i++;
                this.setState({ Taskid: i });
            }
        }
        if (event.keyCode == 8 && event.target.value == "" && event.target.nodeName == "INPUT") {
            var id = event.target.id;
            var num = id.split("task")[1];
            if (document.getElementById("taskid").childNodes.length > 1) {
                var parentnode = document.getElementById('check' + num).parentNode;
                var grandparentnode = parentnode.parentNode;
                var greatgrandparentnode = grandparentnode.parentNode;
                var previouselement = greatgrandparentnode.previousSibling;
                parentnode.removeChild(document.getElementById('check' + num));
                grandparentnode.removeChild(parentnode);
                grandparentnode.removeChild(document.getElementById('task' + num));
                greatgrandparentnode.removeChild(grandparentnode);
                document.getElementById("taskid").removeChild(greatgrandparentnode);
                previouselement.childNodes[0].childNodes[2].focus();
            }
        }
    }

    OnStatusChange() {
        var selectedOption = this.refs.status_in_Select_input.options.selectedIndex;
        var SelectedStatusId = this.refs.status_in_Select_input.options[selectedOption].id;
        this.setState({
            StatusId: SelectedStatusId,
        });
        // if(SelectedStatusId !== '0')
        //     this.refs.status_in_Select_input.style.color = '#000000';
        // else
        //     this.refs.status_in_Select_input.style.color = '#999999';
    }

    OnUserChange() {
        var selectedOption = this.refs.user_in_Select_input.options.selectedIndex;
        var selectedUserId = this.refs.user_in_Select_input.options[selectedOption].id;
        var MailAddress = "";
        if (selectedUserId !== '0' && this.props.getTechnicianList !== undefined && this.props.getTechnicianList.length)
            MailAddress = this.props.getTechnicianList.filter(x => x.technicianID == selectedUserId)[0].emailAddress;
        this.refs.ref_Assigned_User.checked = (MailAddress !== "" && this.props.getMailSetting) ? true : false;
        this.setState({ UserId: selectedUserId, HasEmailAddress: MailAddress !== "" ? true : false, NotifyChecked: this.refs.ref_Assigned_User.checked, SelectedNotifyOthersIds: this.state.SelectedNotifyOthersIds.filter(e => e !== Number(selectedUserId)) });
       
        // if(selectedUserId !== '0')
        //     this.refs.user_in_Select_input.style.color = '#000000';
        // else
        //     this.refs.user_in_Select_input.style.color = '#999999';
    }

    onNotifyOthersSelect(args){
        var l_SelectedNotifyOthersIds = (this.state.SelectedNotifyOthersIds !== undefined && this.state.SelectedNotifyOthersIds.length) ? this.state.SelectedNotifyOthersIds : [];
        l_SelectedNotifyOthersIds.push(args.itemData.id);
        this.setState({SelectedNotifyOthersIds:  l_SelectedNotifyOthersIds})
    }

    onNotifyOthersRemove(args){
        var l_SelectedNotifyOthersIds = this.state.SelectedNotifyOthersIds;
        var FilteredData = l_SelectedNotifyOthersIds.filter(x => x !== args.itemData.id);
        this.setState({SelectedNotifyOthersIds: FilteredData });
    }

    _handleAttachment(e) {
        e.preventDefault();

        this.setState({
            displayImageError: false,
            errorImageName: null,
            errorImageText: " file size limit exceeded.",
        });
        var fileTypes = ['doc', 'docx', 'jpg', 'jpeg', 'png', 'pdf'];

        if (e.target.files && e.target.files[0]) {
            var extension = e.target.files[0].name.split('.').pop().toLowerCase(), //file extension from input file
                fileTypeSuccess = fileTypes.indexOf(extension) > -1;  //is extension in acceptable types
            var fileSize = document.getElementById('myfile').files[0].size; //Checking for file size

            if (fileTypeSuccess && fileSize <= 25000000) {
                let reader = new FileReader();
                let file = e.target.files[0];
                reader.onloadend = () => {
                    const data = new FormData();
                    data.append('file', file);
                    const l_Request = this.props.SaveAttachmentToFolder(data, 0);
                    l_Request.then((result) => {
                        if (this.props.getUniqueAttachmentName !== undefined && this.props.getUniqueAttachmentName !== null && this.props.getUniqueAttachmentName !== []) {
                            this.setState({ image_Array: [...this.state.image_Array, { 'id': 0, 'name': file.name, 'fileName': this.props.getUniqueAttachmentName.FileName }] });
                        }
                    });
                }
                reader.readAsDataURL(file)
                e.target.value = null;
            } else if (fileSize >= 25000000) {
                this.setState({
                    displayImageError: true,
                    errorImageName: e.target.files[0].name,
                    errorImageText: " file size limit exceeded.",
                })
            }
            else {
                this.setState({
                    displayImageError: true,
                    errorImageName: e.target.files[0].name,
                    errorImageText: " file type not supported.",
                });
            }
        }
    }

    DeleteAttachment(element) {
        let lineitem = {
            "AttachmentId": 0,
            "FileName": element,
        }
        this.props.DeleteAttachment(lineitem);

        this.setState({
            image_Array: this.state.image_Array.filter(el => el.fileName != element)
        });
    }

    OnCancel() {
        this.setState({ redirectHome: true });
        if (this.props.ForEquipment !== undefined && this.props.ForEquipment !== null && this.props.ForEquipment == true){
            var l_Cancel = this.props.OnPopupCancel("0");
            l_Cancel(0);
        }
    }

    ClearCustomErrors() {
        this.state.error.customname = false;
        var lCustomColtxts = document.getElementsByClassName("customfieldsColtxt");
        if (lCustomColtxts !== undefined && lCustomColtxts !== null && lCustomColtxts.length) {
            for (var i = 0; i < lCustomColtxts.length; i++) {
                var lChildrens = lCustomColtxts[i].childNodes;
                lChildrens[0].classList.remove('errortext');
                lChildrens[2].classList.remove('errorhighlight');
                lChildrens[2].style.width = "300px";
                lChildrens[3].setAttribute('hidden', true);
            }
        }
        var lCustomColddls = document.getElementsByClassName("customfieldsColddl");
        if (lCustomColddls !== undefined && lCustomColddls !== null && lCustomColddls.length) {
            for (var i = 0; i < lCustomColddls.length; i++) {
                var lChildrens = lCustomColddls[i].childNodes;
                lChildrens[0].classList.remove('errortext');
                lChildrens[2].classList.remove('errorhighlight');
                lChildrens[3].setAttribute('hidden', true);
            }
        }
    }

    OnSavePreventativeMaintenance() {
        this.setState({ IsClickSave: true });
        this.ClearCustomErrors();
        //let label = this.props.getLabels;
        let PMPreferences = this.props.getPreferences;
        var Status = '', AssignedTo = '', Name = '', Building = '', Equipment = '', Schedule = '', Description = '', EstimateTime = '', PartsAndTools = '', TaskList = '', FamilyType = '',NotifyOthers = '';

        if (PMPreferences != undefined && PMPreferences != '') {
            Status = PMPreferences.filter(x => x.field === "Status")[0];
            AssignedTo = PMPreferences.filter(x => x.field === "Assigned To")[0];
            Name = PMPreferences.filter(x => x.field === "Name")[0];
            Building = PMPreferences.filter(x => x.field === "Building")[0];
            Equipment = PMPreferences.filter(x => x.field === "Equipment")[0];
            Schedule = PMPreferences.filter(x => x.field === "Schedule")[0];
            Description = PMPreferences.filter(x => x.field === "Description")[0];
            EstimateTime = PMPreferences.filter(x => x.field === "Estimated Time")[0];
            PartsAndTools = PMPreferences.filter(x => x.field === "Parts & Tools")[0];
            TaskList = PMPreferences.filter(x => x.field === "Task List")[0];
            FamilyType = PMPreferences.filter(x => x.field === "Family Type")[0];
            NotifyOthers = PMPreferences.filter(x => x.field === "Notify Others")[0];
        }

        var Tasks = [];
        if (this.refs.tasklist != undefined) {

            if (this.refs.tasklist.childNodes.length > 0) {
                let j = 0, data = [], ischecked = [];
                let length = document.getElementById('taskid').childNodes.length;
                for (j = 0; j < length; j++) {
                    data.push(document.getElementById('taskid').childNodes[j].childNodes[0].childNodes[2].value);
                    ischecked.push(document.getElementById('taskid').childNodes[j].childNodes[0].childNodes[0].childNodes[0].checked);
                }
                for (j = 0; j < length; j++) {
                    if (data[j] !== "") {
                        var TaskItem = {
                            "TaskDescription": data[j],
                            "IsChecked": ischecked[j]
                        }
                        Tasks.push(TaskItem);
                    }
                }
            }
        }
        (!Status.required || (Status.required && this.state.StatusId > 0)) ? this.state.error.status = false : this.state.error.status = true;
        (!AssignedTo.required || (AssignedTo.required && this.state.UserId > 0)) ? this.state.error.assigneddto = false : this.state.error.assigneddto = true;
        (!Name.required || (Name.required && this.refs.name_in_input.value.trim() != "")) ? this.state.error.name = false : this.state.error.name = true;
        (!Building.required || (Building.required && this.state.BuildingId > 0)) ? this.state.error.building = false : this.state.error.building = true;
        (!Equipment.required || (Equipment.required && this.state.EquipmentId > 0)) ? this.state.error.equipment = false : this.state.error.equipment = true;
        (!Schedule.required || (Schedule.required && this.state.ScheduleType != '0')) ? this.state.error.schedule = false : this.state.error.schedule = true;
        (!Description.required || (Description.required && this.refs.description_in_textarea.value.trim() != '')) ? this.state.error.description = false : this.state.error.description = true;
        (!EstimateTime.required || (EstimateTime.required && this.refs.Time_in_timepicker.picker.value != "")) ? this.state.error.estimate = false : this.state.error.estimate = true;
        (!PartsAndTools.required || (PartsAndTools.required && this.refs.parts_in_input.value != "")) ? this.state.error.parts = false : this.state.error.parts = true;
        (!TaskList.required || (TaskList.required && Tasks.length > 0)) ? this.state.error.tasklist = false : this.state.error.tasklist = true;
        (!FamilyType.required || (FamilyType.required && this.state.FamilyTypeId > 0)) ? this.state.error.familytype = false : this.state.error.familytype = true;
        (!NotifyOthers.required || (NotifyOthers.required && this.state.SelectedNotifyOthersIds.length > 0)) ? this.state.error.notifyOthers = false : this.state.error.notifyOthers = true;

        //custom fields validations
        var lCustomFieldCol = [];
        var lCustomColtxts = document.getElementsByClassName("customfieldsColtxt");
        if (lCustomColtxts !== undefined && lCustomColtxts !== null && lCustomColtxts.length) {
            for (var i = 0; i < lCustomColtxts.length; i++) {
                var lChildrens = lCustomColtxts[i].childNodes;
                var CustomTxtBoxValue = lChildrens[2].value;
                CustomTxtBoxValue = CustomTxtBoxValue.trim();
                var CustomTxtBoxAttr = lChildrens[2].getAttribute("data-key");
                if (CustomTxtBoxAttr.split('~')[1] === "true" && !!CustomTxtBoxValue === false) {
                    lChildrens[0].classList.add('errortext');
                    lChildrens[2].classList.add('errorhighlight');
                    lChildrens[2].style.width = "280px";
                    lChildrens[3].removeAttribute('hidden');
                    this.state.error.customname = true;
                }
                lCustomFieldCol.push({
                    "CustomFieldID": Number(CustomTxtBoxAttr.split('~')[0]),
                    "CustomFieldValueID": 0,
                    "CustomFieldTextValue": CustomTxtBoxValue
                });
            }
        }

        var lCustomColddls = document.getElementsByClassName("customfieldsColddl");
        if (lCustomColddls !== undefined && lCustomColddls !== null && lCustomColddls.length) {
            for (var i = 0; i < lCustomColddls.length; i++) {
                var lChildrens = lCustomColddls[i].childNodes;
                var CustomddlIndex = lChildrens[2].options.selectedIndex;
                var CustomddlValue = lChildrens[2].options[CustomddlIndex].id;
                var CustomddlAttr = lChildrens[2].getAttribute("data-key");
                if (CustomddlAttr.split('~')[1] === "true" && CustomddlValue === "0") {
                    lChildrens[0].classList.add('errortext');
                    lChildrens[2].classList.add('errorhighlight');
                    lChildrens[3].removeAttribute('hidden');
                    this.state.error.customname = true;
                }
                lCustomFieldCol.push({
                    "CustomFieldID": Number(CustomddlAttr.split('~')[0]),
                    "CustomFieldValueID": Number(CustomddlValue),
                    "CustomFieldTextValue": ""
                });
            }
        }

        if (!this.state.error.status && !this.state.error.assigneddto && !this.state.error.name && !this.state.error.building && !this.state.error.equipment
            && !this.state.error.schedule && !this.state.error.description && !this.state.error.estimate && !this.state.error.parts 
            && !this.state.error.tasklist && !this.state.error.familytype && !this.state.error.customname && !this.state.error.notifyOthers) {
            var Attachments = [], AttachmentItems = '';
            if (this.state.image_Array.length) {
                this.state.image_Array.forEach(el => {
                    AttachmentItems = {
                        "Name": el.name,
                        "FileName": el.fileName
                    }
                    Attachments.push(AttachmentItems);
                });
            }


            var recurdate = '1753/01/01';
            if (this.state.RecurrenceDueDate != null && this.state.RecurrenceDueDate != "") {
                var validdate = new Date(this.state.RecurrenceDueDate);
                recurdate = (validdate.getMonth() + 1) + "/" + validdate.getDate() + "/" + validdate.getFullYear();
            }

            var lScheduleData = [];
            var ampScheduleType ; 
            if (this.state.ScheduleType === 1) {
                ampScheduleType = "Based on Calendar";
                lScheduleData = {
                    "StartDate": recurdate,
                    "Modifier": this.state.RepeatEvery,
                    "Interval": this.state.RepeatInterval
                }
            }
            else if (this.state.ScheduleType === 2) {
                ampScheduleType = "Based on Usage";
                lScheduleData = {
                    "StartDate": new Date(),
                    "ObjectId": this.state.PointDetails.objectId,
                    "PropertyId": this.state.PointDetails.propertyId,
                    "LimitValue": this.state.LimitValue,
                    "Dimension": this.state.PointDetails.dimension,
                    "Unit": this.state.PointDetails.unitId,
                    "EquipmentId": this.state.UsageEquipmentId,
                    "ArrayIndex": this.state.PointDetails.arrayIndex
                }
            } else {
                ampScheduleType = "None";
                lScheduleData = {
                    "StartDate": new Date(),
                    "Modifier": 0,
                    "Interval": 0
                }
            }

            var selectedOption = this.refs.familytype_in_Select_input ? this.refs.familytype_in_Select_input.options.selectedIndex : 0;
            var SelectedFamily = this.refs.familytype_in_Select_input != undefined ? this.refs.familytype_in_Select_input.options[selectedOption].id : 0;

            var IsChecked_email = false;//added a condition to check email sending notification
            if (this.refs.ref_Assigned_User != undefined || this.refs.ref_Assigned_User != null)
                IsChecked_email = this.refs.ref_Assigned_User.checked;

            let lineitem = {
                "Status": parseInt(this.state.StatusId),
                "Name": this.refs.name_in_input != undefined ? this.refs.name_in_input.value : "",
                "AssignedTo": parseInt(this.state.UserId),
                "IsMailRequired": IsChecked_email,
                "BuildingId": parseInt(this.state.BuildingId),
                "EquipmentId": this.state.EquipmentId !== "" ? parseInt(this.state.EquipmentId) : 0,
                "IsNonDiscoveredEquipment": this.state.IsNonDiscoveredEquipment,
                "Description": this.refs.description_in_textarea ? this.refs.description_in_textarea.value : "",
                "EstimatedTime": this.refs.Time_in_timepicker != undefined ? (this.refs.Time_in_timepicker.picker.value !== "" ? this.refs.Time_in_timepicker.picker.value : '00:00') : '00:00',
                "PartsTools": this.refs.parts_in_input != undefined ? this.refs.parts_in_input.value : "",
                "Tasks": Tasks,
                "Attachments": (this.state.image_Array.length > 0) ? Attachments : null,
                "DueDate": recurdate,
                "ScheduleType": this.state.ScheduleType,
                "Schedule": lScheduleData,
                "FamilyType": SelectedFamily,
                "CustomFields": lCustomFieldCol,
                "BuildingName": this.state.BuildingName,
                "EquipmentName": this.state.EquipmentName,
                "ScheduleText": this.state.SchduleTypeText,
                "LogicalBuildingId": this.state.LogicalBuildingId, 
                "NotifyUserIDs": this.state.SelectedNotifyOthersIds
            }
            /*Tag Amplitude Event*/
            const isApplyTemplate = (this.state.TemplateID !== '0') ? 'With Template' : 'Without Template';
            setAmplitudeEvent('Create Preventative Maintenance', { 'PM Template': isApplyTemplate,'Maintenance Schedule Type': ampScheduleType, "Notify Others":this.state.SelectedNotifyOthersIds.length });
            const l_Request = this.props.SavePreventativeMaintenance(lineitem, (this.props.AlarmInfo != undefined && this.props.AlarmInfo.length > 0) ? this.props.AlarmInfo[0].EquipmentId : 0);
            l_Request.then((result) => {
                this.setState({ redirectHome: true, IsError: false });
            });
            if (this.props.ForEquipment !== undefined && this.props.ForEquipment !== null && this.props.ForEquipment == true) {
                var l_Cancel = this.props.OnPopupCancel;
                l_Cancel(1);  
            }
        }
        else {
            this.setState({ IsError: true, IsClickSave: false });
        }

    }

    Scheduletoggle() {
        this.setState({
            Schedulemodal: !this.state.Schedulemodal,
            ScheduleTypeRdl: this.state.ScheduleType,
            SchduleTypeText: this.state.SchduleTypeTextRdl,
            DueDateError: false,
            RepeatEveryError: false,
            UsageError: {
                building: false,
                Family: false,
                Equipment: false,
                Point: false,
                limit: false
            }
        });
    }

    OnCancelRecurrencePattern() {
        this.setState({
            Schedulemodal: false,
            ScheduleTypeRdl: this.state.ScheduleType,
            SchduleTypeText: this.state.SchduleTypeTextRdl,
            DueDateError: false,
            RepeatEveryError: false,
            UsageError: {
                building: false,
                Family: false,
                Equipment: false,
                Point: false,
                limit: false
            },
            RecurrenceDueDate: this.state.LastSavedScheduleDts.RecurrenceDueDate,
            RepeatEvery: this.state.LastSavedScheduleDts.RepeatEvery,
            RepeatInterval: this.state.LastSavedScheduleDts.RepeatInterval,
            UsageBuildingId: this.state.LastSavedScheduleDts.UsageBuildingId,
            UsageFamilyTypeId: this.state.LastSavedScheduleDts.UsageFamilyTypeId,
            UsageEquipmentId: this.state.LastSavedScheduleDts.UsageEquipmentId,
            UsagePointId: this.state.LastSavedScheduleDts.UsagePointId,
            UnitName: this.state.LastSavedScheduleDts.UnitName,
            LimitValue: this.state.LastSavedScheduleDts.LimitValue
        });
    }

    OnSaveRecurrencePattern() {
        this.setState({ DueDateError: false, RepeatEveryError: false });
        var Expression = new RegExp('^[0-9]*$');
        if (this.refs.rdl_Calendar.checked) {
            var RepeatValue = this.refs.modifier_in_input.value;
            if (this.state.RecurrenceDueDate === "") {
                this.setState({ DueDateError: true });
            }
            else if (RepeatValue === "" || RepeatValue === "0" || !Expression.test(RepeatValue)) {
                this.setState({ RepeatEveryError: true });
            }
            else {
                var recurdate = new Date(this.state.RecurrenceDueDate);
                var forma = (recurdate.getMonth() + 1) + "/" + recurdate.getDate() + "/" + recurdate.getFullYear();
                var PMScheduleText = "Starting " + forma + ", " + "Repeat every " + ((this.state.RepeatEvery != "1") ? this.state.RepeatEvery : "") + " " + this.props.getLabels['CreatePM.Interval.' + this.state.RepeatInterval + '.Text'] + ((this.state.RepeatEvery != "1") ? "s" : "");
                this.setState({
                    RepeatEvery: RepeatValue, Schedulemodal: false, ScheduleType: 1, SchduleTypeTextRdl: PMScheduleText, SchduleTypeText: PMScheduleText, showScheduleText: true,
                    LastSavedScheduleDts: {
                        RecurrenceDueDate: this.state.RecurrenceDueDate,
                        RepeatEvery: RepeatValue,
                        RepeatInterval: this.state.RepeatInterval,
                        UsageBuildingId: 0, UsageFamilyTypeId: 0, UsageEquipmentId: 0, UsagePointId: 0, UnitName: '', LimitValue: 0
                    }
                });
            }
        } else {
            var UsageLimitValue = this.refs.usage_parameter_in_input.value;
            this.state.UsageError.building = this.state.UsageBuildingId == '0' ? true : false;
            this.state.UsageError.Family = this.state.UsageFamilyTypeId == '0' ? true : false;
            this.state.UsageError.Equipment = (this.state.UsageEquipmentId == '0' && this.state.UsageFamilyTypeId != '7') ? true : false;
            this.state.UsageError.Point = this.state.UsagePointId == '0' ? true : false;
            this.state.UsageError.limit = (UsageLimitValue === "" || UsageLimitValue == '0' || Number.isNaN(Number(UsageLimitValue))) ? true : false;

            if (!this.state.UsageError.building && !this.state.UsageError.Family && !this.state.UsageError.Equipment && !this.state.UsageError.Point && !this.state.UsageError.limit) {
                var SCheduleText = "";
                if (this.state.UsageFamilyTypeId === '7')
                    SCheduleText = this.state.FamilyText + ', ' + this.state.PointText + ', Interval: ' + this.state.LimitValue + ' ' + this.state.UnitName;
                else
                    SCheduleText = this.state.FamilyText + ', ' + this.state.EquipmentText + ', ' + this.state.PointText + ', Interval: ' + this.state.LimitValue + ' ' + this.state.UnitName;
                this.setState({
                    LimitValue: UsageLimitValue, Schedulemodal: false, ScheduleType: 2, SchduleTypeTextRdl: SCheduleText, SchduleTypeText: SCheduleText,
                    HasUsageBuildingChanged: true, HasUsageFamilyChanged: true, HasEquipmentChanged: true, showScheduleText: true,
                    LastSavedScheduleDts: {
                        RecurrenceDueDate: '', RepeatEvery: 0, RepeatInterval: 0,
                        UsageBuildingId: this.state.UsageBuildingId,
                        UsageFamilyTypeId: this.state.UsageFamilyTypeId,
                        UsageEquipmentId: this.state.UsageEquipmentId,
                        UsagePointId: this.state.UsagePointId,
                        UnitName: this.state.UnitName,
                        LimitValue: UsageLimitValue
                    }
                });
            }
        }
    }

    handleChange(date) {
        var recurdate = new Date(date);
        var forma = (recurdate.getMonth() + 1) + "/" + recurdate.getDate() + "/" + recurdate.getFullYear();
        var PMScheduleText = "Starting " + forma + ", " + "Repeat every " + ((this.state.RepeatEvery != "1") ? this.state.RepeatEvery : "") + " " + this.props.getLabels['CreatePM.Interval.' + this.state.RepeatInterval + '.Text'] + ((this.state.RepeatEvery != "1") ? "s" : "");
        this.setState({ RecurrenceDueDate: date, SchduleTypeText: PMScheduleText });
    }

    OnIntervalChange() {
        var selectedOption = this.refs.interval_in_Select_input.options.selectedIndex;
        var SelectedInterval = this.refs.interval_in_Select_input.options[selectedOption].id;
        var recurdate = new Date(this.state.RecurrenceDueDate);
        var forma = (recurdate.getMonth() + 1) + "/" + recurdate.getDate() + "/" + recurdate.getFullYear();
        var PMScheduleText = "Starting " + forma + ", " + "Repeat every " + ((this.state.RepeatEvery != "1") ? this.state.RepeatEvery : "") + " " + this.props.getLabels['CreatePM.Interval.' + SelectedInterval + '.Text'] + ((this.state.RepeatEvery != "1") ? "s" : "");

        this.setState({
            RepeatInterval: SelectedInterval, SchduleTypeText: PMScheduleText
        });
    }

    OnCalendarLimitChange(evt) {
        var recurdate = new Date(this.state.RecurrenceDueDate);
        var forma = (recurdate.getMonth() + 1) + "/" + recurdate.getDate() + "/" + recurdate.getFullYear();
        var PMScheduleText = "Starting " + forma + ", " + "Repeat every " + ((evt.target.value != "1") ? evt.target.value : "") + " " + this.props.getLabels['CreatePM.Interval.' + this.state.RepeatInterval + '.Text'] + ((evt.target.value != "1") ? "s" : "");

        this.setState({ RepeatEvery: evt.target.value, SchduleTypeText: PMScheduleText });
    }

    ScheduleTypeChange() {
        this.setState({
            ScheduleTypeRdl: this.refs.rdl_Calendar.checked ? 1 : 2,
            SchduleTypeText: '',
            DueDateError: false,
            RepeatEveryError: false,
            UsageError: {
                building: false,
                Family: false,
                Equipment: false,
                Point: false,
                limit: false
            }
        });
    }

    LoadBuildingEquipmentFromFamilyType() {
        var selectedOption = this.refs.familytype_in_Select_input.options.selectedIndex;
        var selectedFamilyId = this.refs.familytype_in_Select_input.options[selectedOption].id;
        if (selectedFamilyId !== '7' && selectedFamilyId !== '0') {
            const actionResponse = this.props.GetEquipmentsByFamilyType(this.state.BuildingId, selectedFamilyId);
            actionResponse.then((result) => {
                if (this.props.getEquipmentsByFamily !== undefined && this.props.getEquipmentsByFamily !== null && this.props.getEquipmentsByFamily.length) {
                    var l_Equipmentdata = [];
                    this.props.getEquipmentsByFamily.forEach(element => {
                        var Equiplineitem = {
                            "Id": element.objectId,
                            "Name": element.objectName,
                            "Location": this.state.BuildingName,
                            "SubId": element.familyType == '100' ? 1 : 0,
                        }
                        l_Equipmentdata.push(Equiplineitem);
                    });
                    this.setState({ EquipmentId: 0, EquipmentName: '', EquipmentData: l_Equipmentdata });
                    if (!this.state.HasEquipmentChanged && selectedFamilyId !== '100')
                        this.setState({ UsageEquipments: this.props.getEquipmentsByFamily });
                } else {
                    this.setState({ EquipmentId: 0, EquipmentName: '', EquipmentData: [] });
                }
            })
        } else {
            this.setState({ EquipmentId: 0, EquipmentName: '', EquipmentData: [] });
        }
        this.setState({ FamilyTypeId: selectedFamilyId, FamilyText: this.refs.familytype_in_Select_input.options[selectedOption].value, FamilyTypeName: this.refs.familytype_in_Select_input.options[selectedOption].value });

        if (!this.state.HasUsageFamilyChanged)
            this.setState({ UsageFamilyTypeId: selectedFamilyId });

        if (selectedFamilyId !== '0')
            this.refs.familytype_in_Select_input.style.color = '#000000';
        else
            this.refs.familytype_in_Select_input.style.color = '#999999';
    }

    OnUsageBuildingChange() {
        this.setState({
            UsageFamilyTypes: [], UsageEquipments: [], UsageBuildingPoints: [],
            UsageFamilyTypeId: 0, UsageEquipmentId: 0, UsagePointId: 0
        });
        var selectedOption = this.refs.usage_building_in_Select_input.options.selectedIndex;
        var selectedBuildingId = this.refs.usage_building_in_Select_input.options[selectedOption].id;
        var selectedBuildingName = this.refs.usage_building_in_Select_input.options[selectedOption].value;

        if (selectedBuildingId !== '0') {
            var actualSiteId = 0;
            if (this.props.getWorkOrderBuildings !== undefined && this.props.getWorkOrderBuildings.length > 0 && selectedBuildingId > 0) {
                var l_MappedSite = this.props.getWorkOrderBuildings.filter(x => x.id == selectedBuildingId);
                if (l_MappedSite !== undefined && l_MappedSite.length > 0) {
                    actualSiteId = l_MappedSite[0].siteId;
                }
            }
            const actionResponse = this.props.GetUsageFamilyTypesBySiteId(actualSiteId);
            actionResponse.then((result) => {
                if (this.props.getUsageFamilyTypes !== undefined && this.props.getUsageFamilyTypes !== null && this.props.getUsageFamilyTypes.length) {
                    this.setState({ UsageFamilyTypes: this.props.getUsageFamilyTypes });
                }
            })
        }

        this.setState({ HasUsageBuildingChanged: true, UsageBuildingId: selectedBuildingId, UsageBuildingName: selectedBuildingName });
    }

    OnUsageFamilyTypeChange() {
        this.setState({ UsageEquipments: [], UsageBuildingPoints: [], UsageEquipmentId: 0, UsagePointId: 0 });
        var selectedOption = this.refs.usage_family_in_Select_input.options.selectedIndex;
        var selectedFamilyId = this.refs.usage_family_in_Select_input.options[selectedOption].id;

        var actualSiteId = 0;
        if (this.props.getWorkOrderBuildings !== undefined && this.props.getWorkOrderBuildings.length > 0 && this.state.UsageBuildingId > 0) {
            var l_MappedSite = this.props.getWorkOrderBuildings.filter(x => x.id == this.state.UsageBuildingId);
            if (l_MappedSite !== undefined && l_MappedSite.length > 0) {
                actualSiteId = l_MappedSite[0].siteId;
            }
        }

        if (selectedFamilyId !== '7' && selectedFamilyId !== '0') {
            const actionResponse = this.props.GetUsageEquipmentsByFamilyType(actualSiteId, selectedFamilyId);
            actionResponse.then((result) => {
                if (this.props.getUsageEquipmentsByFamily !== undefined && this.props.getUsageEquipmentsByFamily !== null && this.props.getUsageEquipmentsByFamily.length) {
                    this.setState({ UsageEquipments: this.props.getUsageEquipmentsByFamily });
                }
            })
        } else {
            if (selectedFamilyId === '7') {
                const actionResponse = this.props.GetBuildingPoints(actualSiteId);
                actionResponse.then((result) => {
                    if (this.props.getBuildingPoints !== undefined && this.props.getBuildingPoints !== null && this.props.getBuildingPoints.length) {
                        this.setState({ UsageBuildingPoints: this.props.getBuildingPoints });
                    }
                })
            }
        }
        var FamilyTextValue = this.refs.usage_family_in_Select_input.options[selectedOption].value;
        var SCheduleText = "";
        if (selectedFamilyId === '7')
            SCheduleText = FamilyTextValue + ', ' + this.state.PointText + ', Interval: ' + this.state.LimitValue + ' ' + this.state.UnitName;
        else
            SCheduleText = FamilyTextValue + ', ' + this.state.EquipmentText + ', ' + this.state.PointText + ', Interval: ' + this.state.LimitValue + ' ' + this.state.UnitName;
        this.setState({ HasUsageFamilyChanged: true, UsageFamilyTypeId: selectedFamilyId, FamilyText: FamilyTextValue, SchduleTypeText: SCheduleText });
    }

    OnUsageEquipmentChange() {
        this.setState({ UsageBuildingPoints: [], UsagePointId: 0 });
        var selectedOption = this.refs.usage_equipment_in_Select_input.options.selectedIndex;
        var selectedEquipmentId = this.refs.usage_equipment_in_Select_input.options[selectedOption].id;

        if (selectedEquipmentId != '0') {
            var actualSiteId = 0;
            if (this.props.getWorkOrderBuildings !== undefined && this.props.getWorkOrderBuildings.length > 0 && this.state.UsageBuildingId > 0) {
                var l_MappedSite = this.props.getWorkOrderBuildings.filter(x => x.id == this.state.UsageBuildingId);
                if (l_MappedSite !== undefined && l_MappedSite.length > 0) {
                    actualSiteId = l_MappedSite[0].siteId;
                }
            }
            const actionResponse = this.props.GetBuildingEquipmentPoints(actualSiteId, selectedEquipmentId);
            actionResponse.then((result) => {
                if (this.props.getBuildingEquipmentPoints !== undefined && this.props.getBuildingEquipmentPoints !== null && this.props.getBuildingEquipmentPoints.length) {
                    this.setState({ UsageBuildingPoints: this.props.getBuildingEquipmentPoints });
                }
            })
        }
        var lEquipmentText = this.refs.usage_equipment_in_Select_input.options[selectedOption].value;
        var SCheduleText = "";
        if (this.state.UsageFamilyTypeId === '7')
            SCheduleText = this.state.FamilyText + ', ' + this.state.PointText + ', Interval: ' + this.state.LimitValue + ' ' + this.state.UnitName;
        else
            SCheduleText = this.state.FamilyText + ', ' + lEquipmentText + ', ' + this.state.PointText + ', Interval: ' + this.state.LimitValue + ' ' + this.state.UnitName;
        this.setState({ HasEquipmentChanged: true, UsageEquipmentId: selectedEquipmentId, EquipmentText: lEquipmentText, SchduleTypeText: SCheduleText });
    }

    OnUsagePointsChange() {
        this.setState({ UsagePointId: 0, PointDetails: [], UnitName: '' });
        var selectedOption = this.refs.usage_points_in_Select_input.options.selectedIndex;
        var selectedPointId = this.refs.usage_points_in_Select_input.options[selectedOption].id;
        var lPointDts = {
            "dimension": this.refs.usage_points_in_Select_input.options[selectedOption].getAttribute('dimension'),
            "objectId": this.refs.usage_points_in_Select_input.options[selectedOption].getAttribute('objectId'),
            "propertyId": this.refs.usage_points_in_Select_input.options[selectedOption].getAttribute('propertyid'),
            "unitId": this.refs.usage_points_in_Select_input.options[selectedOption].getAttribute('unitid'),
            "arrayIndex": this.refs.usage_points_in_Select_input.options[selectedOption].getAttribute('arrayindex')
        }
        var lPointText = this.refs.usage_points_in_Select_input.options[selectedOption].value;
        var SCheduleText = "";
        if (this.state.UsageFamilyTypeId === '7')
            SCheduleText = this.state.FamilyText + ', ' + lPointText + ', Interval: ' + this.state.LimitValue + ' ' + this.refs.usage_points_in_Select_input.options[selectedOption].getAttribute('unitname');
        else
            SCheduleText = this.state.FamilyText + ', ' + this.state.EquipmentText + ', ' + lPointText + ', Interval: ' + this.state.LimitValue + ' ' + this.refs.usage_points_in_Select_input.options[selectedOption].getAttribute('unitname');
        this.setState({
            UsagePointId: selectedPointId, PointDetails: lPointDts, UnitName: this.refs.usage_points_in_Select_input.options[selectedOption].getAttribute('unitname'),
            SchduleTypeText: SCheduleText, PointText: lPointText
        });
    }

    OnLimitChange(evt) {
        var SCheduleText = "";
        if (this.state.UsageFamilyTypeId === '7')
            SCheduleText = this.state.FamilyText + ', ' + this.state.PointText + ', Interval: ' + evt.target.value + ' ' + this.state.UnitName;
        else
            SCheduleText = this.state.FamilyText + ', ' + this.state.EquipmentText + ', ' + this.state.PointText + ', Interval: ' + evt.target.value + ' ' + this.state.UnitName;
        this.setState({ SchduleTypeText: SCheduleText, LimitValue: evt.target.value });
    }

    FormCustomFields(IsEquipment) {
        const l_rows = [];
        var Default_drop_down_value = <option value="" id="0" selected>{this.props.getLabels['WorkOrders.DropDown.Default.Text']}</option>
        var PMCustomFields = this.state.CustomFieldCollection;
        if (this.props.getCustomFields !== undefined && this.props.getCustomFields !== null && this.props.getCustomFields.length) {
            var lCustomFields = this.props.getCustomFields.filter(x => x.display === true);
            if (lCustomFields !== undefined && lCustomFields !== null && lCustomFields.length) {
                var l_CustomFields = this.OnSort(lCustomFields);
                const l_lCustomFields = l_CustomFields.map((item, index) => {
                    var l_Value = "";
                    var SelectedValues = PMCustomFields.filter(el => el.CustomFieldID === item.fieldId);
                    if (SelectedValues[0] !== undefined && SelectedValues[0] !== null) {
                        l_Value = (item.fieldType === 0) ? SelectedValues[0].CustomFieldTextValue : SelectedValues[0].CustomFieldValueID;
                    }
                    if (item.fieldType === 0) {
                        return <div className={index % 2 == 0 ? "grid-first-col customfieldsColtxt" : "grid-second-col customfieldsColtxt"} key={item.fieldId}>
                            <Label className="grid-header-lbl CreatePMlbl_margin">{(item.required ? item.fieldLabel + "*" : item.fieldLabel)}</Label>
                            <br />
                            <input type="text" maxLength={50} data-key={item.fieldId + '~' + item.required} defaultValue={l_Value} style={{ width: '300px' }} className="pm_textbox" />
                            <span hidden={true}><Icon name='exclamation triangle' style={ErrorSign} /><br />
                                <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato' }}><b>An entry is required</b></Label></span>
                            </div>
                    } else {
                        var customValue_in_Select_input;
                        if (item.value !== undefined && item.value !== null && item.value.length > 0) {
                            var custom_values = this.OnSort(item.value);
                            customValue_in_Select_input = custom_values.map(el => (
                                <option id={el.key} selected={el.key == l_Value}>{el.value}</option>
                            ));
                        }
                        return <div className={index % 2 == 0 ? "grid-first-col customfieldsColddl" : "grid-second-col customfieldsColddl"} key={item.fieldId}>
                            <Label className="grid-header-lbl CreatePMlbl_margin">{(item.required) ? item.fieldLabel + "*" : item.fieldLabel}</Label><br />
                            <select data-key={item.fieldId + '~' + item.required} id={"ddl_" + item.fieldId} className="minimal workorderedit-dropdown grid-ddl" style={{ width: '300px', "color": (l_Value !== 0 && l_Value !== "") ? '#000000' : "#999999" }} onChange={() => { this.SelectCustomValues("ddl_" + item.fieldId) }}>
                                {Default_drop_down_value}
                                {customValue_in_Select_input}
                            </select>
                            <span hidden={true}><br/><Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato' }}><b>Please make a selection</b></Label></span>
                            </div>
                    }
                });
                for (let row = 0; row < l_CustomFields.length; row++) {
                    l_rows.push(
                        <div key={"div_" + row} className="grid-padding-bottom" style={{"display":"inline-block"}}>
                            {l_lCustomFields.slice((row * 2), ((row + 1) * 2))}
                        </div>
                    );
                };
            }
        }
        return l_rows;
    }

    SelectCustomValues(element) {
        var selectedOption = document.getElementById(element).options.selectedIndex;
        var selectedCustomValueId = document.getElementById(element).options[selectedOption].id;
        if (selectedCustomValueId !== '0')
            document.getElementById(element).style.color = '#000000';
        else
            document.getElementById(element).style.color = '#999999';
    }

    OnTemplateChange() {
        this.setState({ Description: '', EstimatedTime: '', PartsTools: '', Tasks: [], TemplateID: '0', image_Array: [] });
        var lSelectedTemplateDetails = [];
        var selectedOption = this.refs.Template_in_Select_input.options.selectedIndex;
        var SelectedTemplateId = this.refs.Template_in_Select_input.options[selectedOption].id;

        if (this.props.getTemplates !== undefined && this.props.getTemplates !== null && this.props.getTemplates.length) {
            lSelectedTemplateDetails = this.props.getTemplates.filter(x => x.templateId.toString() === SelectedTemplateId);
            if (lSelectedTemplateDetails.length > 0) {
                var lEstimatedTime = null, TaskList = "", lAttachments = [];
                var EstimatedTimeStr = lSelectedTemplateDetails[0].estimatedTime !== "" ? lSelectedTemplateDetails[0].estimatedTime.split(':') : "";
                if (EstimatedTimeStr !== "") {
                    lEstimatedTime = moment(EstimatedTimeStr[0] + ':' + EstimatedTimeStr[1], 'HH:mm');
                }

                if (lSelectedTemplateDetails[0].tasks !== undefined && lSelectedTemplateDetails[0].tasks !== null && lSelectedTemplateDetails[0].tasks.length) {
                    TaskList = lSelectedTemplateDetails[0].tasks.map(el => ({
                        "TaskId": el.taskId,
                        "Description": el.taskDescription,
                        "isChecked": el.isChecked,
                    }));
                }
                if (lSelectedTemplateDetails[0].attachments !== undefined && lSelectedTemplateDetails[0].attachments !== null && lSelectedTemplateDetails[0].attachments.length) {
                    let l_Attachments = lSelectedTemplateDetails[0].attachments.map(el => ({
                        "ID": el.id,
                        "Name": el.name,
                        "FileName": el.fileName
                    }));
                    const l_Request = this.props.SaveAsAttachment(l_Attachments);
                    l_Request.then((result) => {
                        if (this.props.getUniqueAttachmentCollection !== undefined && this.props.getUniqueAttachmentCollection !== null && this.props.getUniqueAttachmentCollection.length) {
                            this.setState({ image_Array: this.props.getUniqueAttachmentCollection })
                        }
                    });
                }
                this.setState({
                    Description: lSelectedTemplateDetails[0].description,
                    EstimatedTime: lEstimatedTime,
                    PartsTools: lSelectedTemplateDetails[0].partsTools,
                    Tasks: TaskList !== "" ? TaskList : "",
                    Taskid: lSelectedTemplateDetails[0].tasks.length > 0 ? (lSelectedTemplateDetails[0].tasks.length) : 1,
                    image_Array: lAttachments
                });
            }
        }
        this.setState({ TemplateID: SelectedTemplateId });
    }

    OnCreateTemplate() {
        var lCustomFieldCol = [];

        var lCustomColtxts = document.getElementsByClassName("customfieldsColtxt");
        if (lCustomColtxts !== undefined && lCustomColtxts !== null && lCustomColtxts.length) {
            for (var i = 0; i < lCustomColtxts.length; i++) {
                var lChildrens = lCustomColtxts[i].childNodes;
                var CustomTxtBoxValue = lChildrens[2].value;
                var CustomTxtBoxAttr = lChildrens[2].getAttribute("data-key");
                lCustomFieldCol.push({
                    "CustomFieldID": Number(CustomTxtBoxAttr.split('~')[0]),
                    "CustomFieldValueID": 0,
                    "CustomFieldTextValue": CustomTxtBoxValue
                });
            }
        }

        var lCustomColddls = document.getElementsByClassName("customfieldsColddl");
        if (lCustomColddls !== undefined && lCustomColddls !== null && lCustomColddls.length) {
            for (var i = 0; i < lCustomColddls.length; i++) {
                var lChildrens = lCustomColddls[i].childNodes;
                var CustomddlIndex = lChildrens[2].options.selectedIndex;
                var CustomddlValue = lChildrens[2].options[CustomddlIndex].id;
                var CustomddlAttr = lChildrens[2].getAttribute("data-key");
                lCustomFieldCol.push({
                    "CustomFieldID": Number(CustomddlAttr.split('~')[0]),
                    "CustomFieldValueID": Number(CustomddlValue),
                    "CustomFieldTextValue": ""
                });
            }
        }
        this.props.OpenAddTemplatePopup(true, -1);
        this.setState({ IsTemplateCreateScreen: true, CustomFieldCollection: lCustomFieldCol, PmName: this.refs.name_in_input != undefined ? this.refs.name_in_input.value : "" });
    }

    UpdatePMName(evt) {
        this.setState({ PmName: evt.target.value });
         var RegexRestrictSpecialCharacter =/^[a-zA-Z0-9_\-.,&()$:! ]*$/.test(evt.target.value);
     (!RegexRestrictSpecialCharacter) ? this.state.error.name = true : this.state.error.name = false;
 }

    render() {
        let IsEquipment = this.props.ForEquipment !== undefined && this.props.ForEquipment !== null ? this.props.ForEquipment : false;
        let label = this.props.getLabels;
        let PMPreferences = this.props.getPreferences;
        var errormsg;
        let error_record = null;
        var ServerDateTime = this.props.getServerTime;
        let HasMailSetting = this.props.getMailSetting;

        let utcOffsetMinute = moment().utcOffset();
        if (utcOffsetMinute >= 0) {
            ServerDateTime = moment(moment.parseZone(ServerDateTime).format("YYYY-MM-DD")).add(utcOffsetMinute, 'minutes')
        }
        else {
            ServerDateTime = moment(moment.parseZone(ServerDateTime).format("YYYY-MM-DD")).subtract(utcOffsetMinute, 'minutes')
        }

        if (this.state.redirectHome && !IsEquipment) {
            return <Redirect to={"/ManagePreventativeMaintenance"} />
        } else if (this.state.redirectHome && IsEquipment) {
            return <Redirect to={"/EquipmentWrapper"} />
        }

        if (this.state.error.estimate) {
            var x = document.getElementsByClassName("rc-time-picker-input");
            if (x.length > 0)
                x[0].className = "rc-time-picker-error";
        }
        else {
            var x = document.getElementsByClassName("rc-time-picker-error");
            if (x.length > 0)
                x[0].className = "rc-time-picker-input";
        }

        var selecterrortext = <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato', 'margin-bottom': '-1px' }}><b>Please make a selection</b></Label>
        var assigneeselecterrortext = <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato', 'margin-bottom': '-1px' }}><b>Please make a selection</b></Label>

        if (this.state.IsError) {
            errormsg = <p className="grid-error" style={{"margin-right": !this.props.ForEquipment ? "-416px" : "-23px", "color": '#D42D27', 'font-family': 'Lato', "font-style": 'italic', border: '2px solid #D42D27', height: '40px',
            padding: '10px', float: 'right'}} >
                <Icon name='exclamation triangle' style={ErrorSign} />
                <b>Please correct all errors before continuing.</b>
            </p>
        }

        var Status = '', AssignedTo = '', Name = '', Building = '', Equipment = '', Schedule = '', Description = '', EstimateTime = '', PartsAndTools = '', TaskList = '', FamilyType = '',NotifyOthers = '';

        if (PMPreferences != undefined && PMPreferences != '') {
            Status = PMPreferences.filter(x => x.field === "Status" && x.display === true);
            AssignedTo = PMPreferences.filter(x => x.field === "Assigned To" && x.display === true);
            Name = PMPreferences.filter(x => x.field === "Name" && x.display === true);
            Building = PMPreferences.filter(x => x.field === "Building" && x.display === true);
            Equipment = PMPreferences.filter(x => x.field === "Equipment" && x.display === true);
            Schedule = PMPreferences.filter(x => x.field === "Schedule" && x.display === true);
            Description = PMPreferences.filter(x => x.field === "Description" && x.display === true);
            EstimateTime = PMPreferences.filter(x => x.field === "Estimated Time" && x.display === true);
            PartsAndTools = PMPreferences.filter(x => x.field === "Parts & Tools" && x.display === true);
            TaskList = PMPreferences.filter(x => x.field === "Task List" && x.display === true);
            FamilyType = PMPreferences.filter(x => x.field === "Family Type" && x.display === true);
            NotifyOthers = PMPreferences.filter(x => x.field === "Notify Others" && x.display === true);
        }

        var Default_drop_down_value = <option value="" id="0" selected>{label['PreventativeMaintenance.DropDown.Default.Text']}</option>
        var Default_drop_down_value_Unselected = <option value="" id="0" >{label['PreventativeMaintenance.DropDown.Default.Text']}</option>
        var status_in_Select_input = null, technicians_in_Select_input = null, buildings_in_Select_input = null, interval_in_Select_input = null, familytype_in_Select_input = null;
        var usage_buildings_in_Select_input = null, usage_familytype_in_Select_input = null, usage_equipment_in_Select_input = null, usage_point_in_Select_input = null;
        var BuildingsList, Attachment_Table = "";
        var HasUsageSelected = this.state.ScheduleTypeRdl === 2 ? true : false;
        var template_in_Select_input = null;
        var notifiers_in_Select_input = [];

        if (this.props.getTemplates !== undefined && this.props.getTemplates !== null && this.props.getTemplates.length) {
            template_in_Select_input = this.props.getTemplates.sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) - (a.name.toLowerCase() < b.name.toLowerCase())).map(el => (
                <option id={el.templateId} selected={el.templateId == this.state.TemplateID}>{el.name}</option>
            ));
        }

        var Interval = label['CreatePM.Interval.Text'].split(',');
        if (Interval.length > 0) {
            interval_in_Select_input = Interval.map(el => (
                <option id={el} value={el} selected={el == this.state.RepeatInterval}>{label['CreatePM.Interval.' + el + '.Text']}</option>
            ));
        }

        var status = label['PreventativeMaintenance.Status.Text'].split(',');
        if (Status.length > 0) {
            if (Status[0].value.length > 0) {
                var status_values = this.OnSort(Status[0].value);
                status_in_Select_input = status_values.map(el => (
                    <option id={el.key} value={el.key} selected={el.key == this.state.StatusId ? true : false}>{el.value}</option>
                ));
            }
            else {
                status_in_Select_input = status.map(el => (
                    <option id={el} value={el} selected={el == this.state.StatusId ? true : false}>{label['PreventativeMaintenance.Status.' + el + '.Text']}</option>
                ));

            }
        }

        if (this.props.getTechnicianList != undefined && this.props.getTechnicianList != null) {
            let lSortedTechnicianlst = this.props.getTechnicianList.sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) - (a.name.toLowerCase() < b.name.toLowerCase()));
            technicians_in_Select_input = lSortedTechnicianlst.map(el => (
                <option id={el.technicianID}>{el.name}</option>
            ));
            lSortedTechnicianlst.forEach(el => {
                if(el.technicianID !== Number(this.state.UserId) && el.emailAddress !== ""){
                    notifiers_in_Select_input.push({ "id": el.technicianID, "value" : el.name })
                }
            });
        }

        if (this.state.FamilyTypes !== undefined && this.state.FamilyTypes !== null && this.state.FamilyTypes.length) {
            familytype_in_Select_input = this.state.FamilyTypes.map(el => (
                <option id={el.familyId} selected={this.state.FamilyTypeId == el.familyId}>{el.familyName}</option>
            ));
        } else {
            familytype_in_Select_input = null;
        }

        if (this.state.UsageFamilyTypes !== undefined && this.state.UsageFamilyTypes !== null && this.state.UsageFamilyTypes.length) {
            var FilterOthers = this.state.UsageFamilyTypes.filter(el => el.familyId !== "100");
            usage_familytype_in_Select_input = FilterOthers.map(el => (
                <option id={el.familyId} selected={this.state.UsageFamilyTypeId == el.familyId}>{el.familyName}</option>
            ));
        } else {
            usage_familytype_in_Select_input = null;
        }

        if (this.state.UsageEquipments !== undefined && this.state.UsageEquipments !== null && this.state.UsageEquipments.length) {
            usage_equipment_in_Select_input = this.state.UsageEquipments.map(el => (
                <option id={el.objectId} selected={this.state.UsageEquipmentId == el.objectId}>{el.objectName}</option>
            ));
        } else {
            usage_equipment_in_Select_input = null;
        }

        if (this.state.UsageBuildingPoints !== undefined && this.state.UsageBuildingPoints !== null && this.state.UsageBuildingPoints.length) {
            var BcuBuildings = this.state.UsageBuildingPoints.filter(el => el.propertyId === 85);
            if (BcuBuildings.length > 0) {
                usage_point_in_Select_input = this.state.UsageBuildingPoints.map(el => (
                    <option id={el.objectId} ObjectId={el.objectId} PropertyId={el.propertyId} ArrayIndex={el.arrayIndex} Dimension={el.dimension} UnitId={el.unitId} UnitName={el.unitName} selected={this.state.UsagePointId == el.objectId}>{el.name}</option>
                ));
            } else {
                usage_point_in_Select_input = this.state.UsageBuildingPoints.map(el => (
                    <option id={el.propertyId} ObjectId={el.objectId} PropertyId={el.propertyId} ArrayIndex={el.arrayIndex} Dimension={el.dimension} UnitId={el.unitId} UnitName={el.unitName} selected={this.state.PointDetails.propertyId == el.propertyId && this.state.PointDetails.arrayIndex == el.arrayIndex}>{el.name}</option>
                ));
            }
        } else {
            usage_point_in_Select_input = null;
        }

        if (this.props.getWorkOrderBuildings != null && this.props.getWorkOrderBuildings != undefined && this.props.getWorkOrderBuildings.length > 0)
            BuildingsList = this.props.getWorkOrderBuildings.filter(el => el.isDeleted == false).sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) - (a.name.toLowerCase() < b.name.toLowerCase()));
        if (BuildingsList != null && BuildingsList != undefined && BuildingsList.length > 0) {
            if (this.props.ForEquipment && this.state.BuildingId > 0) {
                buildings_in_Select_input = BuildingsList.map(el => (
                    <option id={el.id} data-buildingDate={el.buildingDate} selected={el.id == this.state.BuildingId} >{el.name}</option>
                ));
            }
            else {
                buildings_in_Select_input = BuildingsList.map(el => (
                    <option id={el.id} data-buildingDate={el.buildingDate}>{el.name}</option>
                ));
            }

            var l_DiscoveredSites = BuildingsList.filter(x => x.siteId !== 0);
            usage_buildings_in_Select_input = l_DiscoveredSites.map(el => (
                <option id={el.id} selected={this.state.UsageBuildingId == el.id}>{el.name}</option>
            ));
        }

        if (this.props.getBuildingEquipments != undefined && this.props.getBuildingEquipments.length > 0 &&
            (this.state.BuildingId === undefined || this.state.BuildingId <= 0) && this.state.EquipmentData.length == 0) {
            var l_Equipmentdata = [], Equiplineitem = '';

            this.props.getBuildingEquipments.forEach(building => {
                if (building.equipment !== undefined && building.equipment !== null && building.equipment.length > 0) {
                    let siteName = building.siteName;
                    building.equipment.forEach(element => {
                        Equiplineitem = {
                            "Id": element.objectId,
                            "Name": element.objectName,
                            "Location": siteName,
                            "SubId": 0,
                        }
                        l_Equipmentdata.push(Equiplineitem);
                    });
                }
            });

            if (this.props.getEquipments != undefined && this.props.getEquipments.length > 0) {
                this.props.getEquipments.forEach(NonDiscEquip => {
                    Equiplineitem = {
                        "Id": NonDiscEquip.id,
                        "Name": NonDiscEquip.name,
                        "Location": NonDiscEquip.buildingName,
                        "SubId": 1,
                    }
                    l_Equipmentdata.push(Equiplineitem);
                });
            }

            this.state.EquipmentData = l_Equipmentdata;
        }

        error_record = <tr>
            <td width="100%"><Icon name='exclamation triangle' style={{ marginRight: '1px', padding: '0px', color: '#D42D27' }} />{" An error has occurred. "}{this.state.errorImageName}{this.state.errorImageText}</td><td></td>
        </tr>

        if (this.state.image_Array != null && this.state.image_Array.length > 0) {
            Attachment_Table = this.state.image_Array.map(el => (
                <tr>
                    <td className="workorderlbl" style={{ "width": "90%", "word-wrap": "break-word" }}>{el.name}</td>

                    <td width="10%"><img src={DeleteIcon} className="Ensemble_Icon link_cursor" style={{ valign: 'bottom', width: '15px', height: '14px' }} onClick={() => { this.DeleteAttachment(el.fileName) }} /></td>
                </tr>
            ));
        }
        else {
            Attachment_Table = <tr><td className="workorderlbl-noentry">{"No attachments"}</td><td>{" "}</td></tr>
        }

        //Applying Custom Fields
        let lstCustomFields = this.FormCustomFields(IsEquipment);

        return (
            <div className={this.props.Premise ? "main_container" : "cloud_main_container"}>
                {
                    this.state.IsTemplateCreateScreen ? <div className="border_container">&nbsp;<CreatePMTemplate Premise={this.props.Premise} TemplateId={-1} Equipment={IsEquipment} Page='Create PM Page' /></div> :
                    <div> 
                    <div className="border_container">
                        <div className="main_container" style={{"width" : "675px"}}>
                            {/*Header */}
                            <div className="grid-padding-bottom">
                                <Label className='grid-header'>{label['PreventativeMaintenance.CreatePreventativeMaintenance.Text']}</Label>
                                {errormsg}
                            </div>

                            {/*First Row - Name*/}
                            {   (Name.length > 0) ? <div className="grid-padding-bottom">
                                    <Label className={(this.state.error.name) ? "errortext grid-header-lbl CreatePMlbl_margin" : "grid-header-lbl CreatePMlbl_margin"}>{(Name[0].required) ? Name[0].fieldLabel + "*" : Name[0].fieldLabel}</Label>
                                    <br />
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <input type="text" maxLength="50" ref='name_in_input' id="input_PM_Name" style={{ "width": "620px" }} className={(this.state.error.name) ? "errorhighlight pm_textbox" : "pm_textbox"} onChange={evt => this.UpdatePMName(evt)} />
                                        {this.state.error.name ? <Icon name='exclamation triangle' style={ErrorSign} /> : null}
                                    </div>
                                    <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato', 'margin-bottom': '-1px' }} hidden={!this.state.error.name}><b>Name can only contain letters, numbers, and the following characters _-.,&()$:!</b></Label>
                                </div> : null
                            }

                            {/*Second Row - Assign and Status*/}
                            {   (AssignedTo.length > 0 || Status.length > 0) ? <div className="grid-padding-bottom"> 
                                {   (Status.length > 0) ?
                                    <div className="grid-first-col">
                                        <Label className={(this.state.error.status) ? "errortext grid-header-lbl CreatePMlbl_margin" : "grid-header-lbl CreatePMlbl_margin"}>{(Status[0].required) ? Status[0].fieldLabel + "*" : Status[0].fieldLabel}</Label>
                                        <br />
                                        <select ref='status_in_Select_input' id="input_PM_Status" className={(this.state.error.status) ? "errorhighlight minimal workorderedit-dropdown grid-ddl" : "minimal workorderedit-dropdown grid-ddl"} style={{ width: '300px', "color": this.state.StatusId != '0' ? '#000000' : '#999999' }} placeholder={label['PreventativeMaintenance.DropDown.Default.Text']} onChange={this.OnStatusChange} >
                                            {Default_drop_down_value}
                                            {status_in_Select_input}
                                        </select>
                                        { this.state.error.status ? <br/> : ""}
                                        <span hidden={!this.state.error.status}>{selecterrortext}</span>
                                    </div> : ""
                                }
                                {   (AssignedTo.length > 0) ?
                                    <div className="grid-second-col">
                                        <Label className={(this.state.error.assigneddto) ? "errortext grid-header-lbl CreatePMlbl_margin" : "grid-header-lbl CreatePMlbl_margin"}>{(AssignedTo[0].required) ? AssignedTo[0].fieldLabel + "*" : AssignedTo[0].fieldLabel}</Label>
                                        <br />
                                        <select ref='user_in_Select_input' id="input_PM_AssignedTo" className={(this.state.error.assigneddto) ? "errorhighlight minimal workorderedit-dropdown grid-ddl" : "minimal workorderedit-dropdown grid-ddl"} style={{ width: '300px', "color": this.state.UserId != '0' ? '#000000' : '#999999' }} placeholder={label['PreventativeMaintenance.DropDown.Default.Text']} onChange={this.OnUserChange} >
                                            {Default_drop_down_value}
                                            {technicians_in_Select_input}
                                        </select>
                                        { this.state.error.assigneddto ? <br/> : ""}
                                        <span hidden={!this.state.error.assigneddto}>{assigneeselecterrortext}</span>
                                        {   (AssignedTo.length > 0) ?
                                            <p style={{ marginBottom: '12px', marginTop: '4px' }}>
                                                <input type="checkbox" style={{ 'vertical-align': 'middle', 'float': 'left' }} id="assigned_box" disabled={!HasMailSetting || !this.state.HasEmailAddress} defaultChecked={this.state.NotifyChecked} ref="ref_Assigned_User" onClick={(event) => this.setState({NotifyChecked: event.target.checked})}/> <div className="grid-notify-aesignee">Notify Assignee</div>
                                            </p> : ""
                                        }
                                   </div> : ""
                                }
                            </div> : ""
                            }

                            {/*Third row - Notify Others*/}
                            { (NotifyOthers.length > 0) ?
                            <div className="grid-padding-bottom">
                                <div className="grid-first-col">
                                    <Label className={(this.state.error.notifyOthers) ? "errortext grid-header-lbl CreatePMlbl_margin" : "grid-header-lbl CreatePMlbl_margin"}>{(NotifyOthers[0].required) ? NotifyOthers[0].fieldLabel + "*" : NotifyOthers[0].fieldLabel}</Label>
                                    <br />
                                    <MultiSelectComponent id="select_pmnotifyothers" ref='pmnotifyothers_in_Select_input' width='300px' cssClass={(this.state.error.notifyOthers) ? classnames("arrowdown-error multiselect-dropdown", "arrowdown multiselect-dropdown") : "arrowdown multiselect-dropdown multiselect-grid-ddl"} style={{"color": this.state.UserId != '0' ? '#000000' : '#999999' }}
                                        dataSource={notifiers_in_Select_input}
                                        fields={this.dropdown_fields}
                                        mode="CheckBox"
                                        select={this.onNotifyOthersSelect.bind(this)}
                                        removed={this.onNotifyOthersRemove.bind(this)}
                                        value={this.state.SelectedNotifyOthersIds}
                                        showSelectAll={true} enableSelectionOrder={false}
                                        filterBarPlaceholder="Search" placeholder="Select" selectAllText="Select All" unSelectAllText="Clear All" >
                                        <Inject services={[CheckBoxSelection]} />
                                    </MultiSelectComponent>
                                    { this.state.error.notifyOthers ? <br/> : ""}
                                    <span hidden={!this.state.error.notifyOthers}>{assigneeselecterrortext}</span>
                                </div>
                            </div> :""}

                            {/*Details Header Row*/}
                            <div className="grid-padding-bottom"> 
                                <div className="grid-first-col" style={{"width":"620px", "padding-top":"10px"}}>
                                    <Label className='grid-type-lbl'>{label['PreventativeMaintenance.Details.Text'] !== undefined ? label['PreventativeMaintenance.Details.Text'] : "Details"}</Label>
                                </div>
                            </div>

                            {/*Fourth row - Building*/}
                            {   (Building.length > 0) ? <div className="grid-padding-bottom"><div className="grid-first-col" style={{"width":"620px", "padding-bottom":"16px"}}>
                                    <Label className={(this.state.error.building) ? "errortext grid-header-lbl CreatePMlbl_margin" : "grid-header-lbl CreatePMlbl_margin"}>{(Building[0].required) ? Building[0].fieldLabel + "*" : Building[0].fieldLabel}</Label>
                                    <br />
                                    <select ref='buildings_in_Select_input' id="input_PM_Building" className={(this.state.error.building) ? "errorhighlight minimal workorderedit-dropdown grid-ddl" : "minimal workorderedit-dropdown grid-ddl"} style={{ width: '300px', "color": this.state.BuildingId != '0' ? '#000000' : '#999999' }} placeholder={label['PreventativeMaintenance.DropDown.Default.Text']} onChange={this.LoadBuildingEquipment} >
                                        {this.props.ForEquipment ? Default_drop_down_value_Unselected : Default_drop_down_value}
                                        {buildings_in_Select_input}
                                    </select>
                                    <span hidden={!this.state.error.building}><br />{selecterrortext}</span>
                                </div></div> : ""
                            }

                            {/*Fifth row - Family Types and Equipment*/}
                            {(FamilyType.length > 0 || Equipment.length > 0) ?<div className="grid-padding-bottom">
                                {(FamilyType.length > 0) ?
                                    <div className="grid-first-col" style={{"padding-bottom":"16px"}}>
                                        <Label className={(this.state.error.familytype) ? "errortext grid-header-lbl CreatePMlbl_margin" : "grid-header-lbl CreatePMlbl_margin"}>{(FamilyType[0].required) ? FamilyType[0].fieldLabel + "*" : FamilyType[0].fieldLabel}</Label>
                                        <br />
                                        <select ref='familytype_in_Select_input' id="input_PM_FamilyType" selectedValue={this.state.FamilyTypeName} className={(this.state.error.familytype) ? "errorhighlight minimal workorderedit-dropdown grid-ddl" : "minimal workorderedit-dropdown grid-ddl"} style={{ width: '300px', "color": this.state.FamilyTypeId != '0' ? '#000000' : '#999999' }} placeholder={label['PreventativeMaintenance.DropDown.Default.Text']} onChange={this.LoadBuildingEquipmentFromFamilyType} >
                                            {this.props.ForEquipment ? Default_drop_down_value_Unselected : Default_drop_down_value}
                                            {familytype_in_Select_input}
                                        </select>
                                        { this.state.error.familytype ? <br/> : ""}
                                        <span hidden={!this.state.error.familytype}>{selecterrortext}</span>
                                    </div> : ""
                                }
                                {(Equipment.length > 0) ?
                                    <div className="grid-second-col" style={{"padding-bottom":"16px"}}>
                                        <Label className={(this.state.error.equipment) ? "errortext grid-header-lbl CreatePMlbl_margin" : "grid-header-lbl CreatePMlbl_margin"}>{(Equipment[0].required) ? Equipment[0].fieldLabel + "*" : Equipment[0].fieldLabel}</Label>
                                        <br />
                                        <input type="text" ref='equipments_in_Select_input' id="input_PM_Equipment" style={{ width: '300px' }} className={(this.state.error.equipment) ? "errorhighlight minimal workorderedit-dropdown grid-ddl" : "minimal workorderedit-dropdown grid-ddl"} placeholder={label['PreventativeMaintenance.DropDown.Default.Text']} value={this.state.EquipmentName} onClick={this.ComputeEquipmentStyle} />
                                        { this.state.error.equipment ? <br/> : ""}
                                        <span hidden={!this.state.error.equipment}>{selecterrortext}</span>
                                    </div> : ""
                                }
                            </div> : ""
                            }

                            {/*Sixth row - Schedule*/}
                            {   (Schedule.length > 0) ? <div className="grid-padding-bottom"><div className="grid-first-col" style={{"width":"620px", "padding-bottom":"16px"}}> 
                                    <Label className={(this.state.error.schedule) ? "errortext grid-header-lbl CreatePMlbl_margin" : "grid-header-lbl CreatePMlbl_margin"}>{(Schedule[0].required) ? Schedule[0].fieldLabel + "*" : Schedule[0].fieldLabel}</Label>
                                    <br />
                                    {   (!this.state.showScheduleText) ?
                                    <div style={{ "width": "300px" }}>
                                        <label style={{ 'cursor': 'pointer', 'margin-bottom': '0px', 'width': '100%' }}>
                                            <input type="text" ref='schedule_in_Select_input' id="input_PM_Schedule" style={{ width: '100%', background: '#F4F4F4' }} className={(this.state.error.schedule) ? "errorhighlight workorderedit-dropdown grid-ddl" : "workorderedit-dropdown grid-ddl"} placeholder={label['PreventativeMaintenance.DropDown.Recurrence.Text']} onClick={this.Scheduletoggle} />
                                            <div className="pm_calendardiv">
                                                <FaRegCalendarAlt className="pm_calendarbox" />
                                            </div>
                                        </label>
                                        { this.state.error.schedule ? <br/> : ""}
                                        <span hidden={!this.state.error.schedule} style={{ display: 'block' }}>{selecterrortext}</span>
                                    </div> : <div>
                                        <Label className="workorderlbl CreatePMlbl_margin" style={{ display: 'inline' }}>{this.state.SchduleTypeText}</Label>
                                        <Edit className="Ensemble_Building_Icon pm_Shedule_Edit" onClick={this.Scheduletoggle} />
                                    </div>
                                }
                                </div></div> : ""
                            }

                            {/*Custom fields row*/}
                            {lstCustomFields}

                            {/* Hr Line */}
                            <div className="grid-padding-bottom">
                                <div className="grid-first-col" style={{"width":"620px", "padding-top": lstCustomFields.length ? "0px" : "10px", "padding-bottom":"16px"}}>
                                    <hr style={{ backgroundColor: '#666666', border: 'none', height: '1px' }} />
                                </div>
                            </div>

                            {/* Template Butons */}
                            <div className="grid-padding-bottom">
                                <div className="grid-first-col" style={{"width":"620px", "margin-top": "-10px", "padding-bottom": "10px"}}>
                                    <Label className='grid-type-lbl' style={{"margin-top":"-1px"}}>{label['PreventativeMaintenance.MaintenanceType.Text'] !== undefined ? label['PreventativeMaintenance.MaintenanceType.Text'] : "Maintenance Type"}</Label>
                                    <button className="child_tab_button_template btn" id="btn_PM_Template" style={{ width: '200px', height: "28px", "margin-left": "15px", "margin-top": "0px" }} onClick={this.OnCreateTemplate}>Create New Template</button>
                                    {   template_in_Select_input !== null ?
                                        <select ref='Template_in_Select_input' id="input_PM_Template" className="template-ddl" style={{ width: '200px', "float": "right" }} onChange={this.OnTemplateChange} >
                                            <option value="" id="0" selected>Use Saved Template</option>
                                            {template_in_Select_input}
                                        </select> : ""
                                    }
                                </div>
                            </div>
                                
                            {/*Template first row - Estimate*/}
                            {   (EstimateTime.length > 0) ? <div className="grid-padding-bottom"><div className="grid-first-col" style={{"width":"620px", "padding-bottom":"16px"}}>
                                    <Label className={(this.state.error.estimate) ? "errortext grid-header-lbl CreatePMlbl_margin" : "grid-header-lbl CreatePMlbl_margin"}>{(EstimateTime[0].required) ? EstimateTime[0].fieldLabel + "*" : EstimateTime[0].fieldLabel}</Label>
                                    <br />
                                    <label style={{ 'cursor': 'pointer', marginBottom: '0px' }} className={(this.state.error.estimate) ? "errorhighlight" : ""}>
                                        <TimePicker ref="Time_in_timepicker" id="input_PM_EstimateTime" popupStyle={{ zIndex: this.props.ForEquipment ? 2147483646 : 1050 }} showSecond={false} open={this.state.open} onOpen={this.setOpen} onClose={this.setClose} style={{ width: '100%' }} focusOnOpen
                                            value={this.state.EstimatedTime} onChange={value => this.setState({ EstimatedTime: value })} />
                                        <div className="pm_timerdiv">
                                            <FaClock className="pm_calendarbox" width="17px" height="17px" />
                                        </div>
                                    </label>
                                    { this.state.error.estimate ? <br/> : ""}
                                    <span hidden={!this.state.error.estimate} style={{ display: 'block' }}>{selecterrortext}</span>
                            </div></div> : ""
                            }

                            {/*Template second row - Description*/}
                            {   (Description.length > 0) ? <div className="grid-padding-bottom"><div className={(this.state.error.description) ? this.props.ForEquipment ?  "grid-first-col grid-first-col-equip-error" : "grid-first-col grid-first-col-error" : "grid-first-col"} style={{"padding-bottom":"16px"}}> 
                                        <Label className={(this.state.error.description) ? "errortext grid-header-lbl CreatePMlbl_margin" : "grid-header-lbl CreatePMlbl_margin"}>{(Description[0].required) ? Description[0].fieldLabel + "*" : Description[0].fieldLabel}</Label>
                                        <br />
                                        <textarea ref='description_in_textarea' id="input_PM_Description" style={{ width: '620px', verticalAlign: 'text-bottom' }} className={(this.state.error.description) ? "errorhighlight workorderedit-textarea workorderheaderlbl" : "workorderedit-textarea workorderheaderlbl"}
                                            value={this.state.Description} onChange={evt => this.setState({ Description: evt.target.value })} />
                                        <span hidden={!this.state.error.description} style={{ position: 'relative', top: '-5px' }}><Icon name='exclamation triangle' style={ErrorSign} /><br />
                                            <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato', 'margin-bottom': '-1px' }}><b>An entry is required</b></Label>
                                        </span>
                            </div></div> : ""
                            }
                            
                            {/*Template third row - Parts and Tools*/}
                            {   (PartsAndTools.length > 0) ?<div className="grid-padding-bottom"><div className={(this.state.error.parts) ? this.props.ForEquipment ?  "grid-first-col grid-first-col-equip-error" : "grid-first-col grid-first-col-error" : "grid-first-col"} style={{"padding-bottom":"16px"}}> 
                                        <Label className={(this.state.error.parts) ? "errortext grid-header-lbl CreatePMlbl_margin" : "grid-header-lbl CreatePMlbl_margin"}>{(PartsAndTools[0].required) ? PartsAndTools[0].fieldLabel + "*" : PartsAndTools[0].fieldLabel}</Label>
                                        <br />
                                        <textarea ref='parts_in_input' id="input_PM_PartsTools" style={{ width: '620px', verticalAlign: 'text-bottom' }} className={(this.state.error.parts) ? "errorhighlight pm_box" : "pm_box"}
                                            value={this.state.PartsTools} onChange={evt => this.setState({ PartsTools: evt.target.value })} />
                                        <span hidden={!this.state.error.parts} style={{ position: 'relative', top: '-5px' }}><Icon name='exclamation triangle' style={ErrorSign} /><br />
                                            <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato', 'margin-bottom': '-1px' }}><b>An entry is required</b></Label>
                                        </span>
                            </div></div> : ""
                            }

                            {/*Template fourth row - Task list*/}
                            {   (TaskList.length > 0) ? <div className="grid-padding-bottom"><div className={(this.state.error.tasklist) ? this.props.ForEquipment ?  "grid-first-col grid-first-col-equip-error" : "grid-first-col grid-first-col-error" : "grid-first-col"} style={{"padding-bottom":"16px"}}> 
                                        <Label className={(this.state.error.tasklist) ? "errortext grid-header-lbl CreatePMlbl_margin" : "grid-header-lbl CreatePMlbl_margin"}>{(TaskList[0].required) ? TaskList[0].fieldLabel + "*" : TaskList[0].fieldLabel}</Label>
                                        <br />
                                        <div ref="tasklist" id="tasklist" style={{ width: '620px', display: 'inline-block', padding: '2px' }} className={(this.state.error.tasklist) ? "errorhighlight pm_tasklist" : "pm_tasklist"}>
                                            <table style={{ width: '100%' }}>
                                                <tbody id="taskid">
                                                    {(this.state.Tasks !== null && this.state.Tasks.length !== 0) ? this.state.Tasks.map((el, index) => (
                                                        <tr key={"Task_" + el.TaskId + "_" + (index + 1)}>
                                                            <td className="col-sm-12" style={{ padding: '0px' }}>
                                                                <span contentEditable="false"><input type="checkbox" defaultChecked={el.isChecked} id={"check" + (index + 1)} style={{ 'vertical-align': 'middle' }} /></span>&nbsp;
                                                                <input type="text" style={{ border: 'none', backgroundColor: 'rgb(244,244,244)', 'vertical-align': 'middle', width: '90%' }} onKeyUp={this.keyPressed} contentEditable="true" defaultValue={el.Description} id={"task" + (index + 1)}></input>
                                                            </td>
                                                        </tr>)) :
                                                        <tr key={"Task_" + this.state.TemplateID}>
                                                            <td className="col-sm-12" style={{ padding: '0px' }}>
                                                                <span><input type="checkbox" style={{ 'vertical-align': 'middle' }} id="check0"/></span>&nbsp;
                                                                <input type="text" style={{ border: 'none', backgroundColor: 'rgb(244,244,244)', 'vertical-align': 'middle', width: this.props.ForEquipment ? '90%' : '95%' }} onKeyUp={this.keyPressed} contenteditable="true" id="task0"/>
                                                            </td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                        <span hidden={!this.state.error.tasklist} style={{ position: 'relative', top: '-5px' }}><Icon name='exclamation triangle' style={ErrorSign} /><br />
                                            <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato', 'margin-bottom': '-1px' }}><b>An entry is required</b></Label>
                                        </span>
                            </div></div> : ""
                            }

                            {/*Template fifth row - attachments*/}
                            <div className="grid-padding-bottom"><div style={{"width":"620px"}}>
                                <Label className="grid-header-lbl" style={{"float":"left", "padding-top":"10px"}}>{label['WorkOrders.Heading.Attachments.Text']}</Label>
                                <Label className="workorderedit-choosebtn" style={{ float: 'right', "margin-top": "10px" }}>
                                    <input type="file" id="myfile" onChange={(e) => this._handleAttachment(e)} />{label['WorkOrderEdit.ChooseFile.Text']}
                                </Label>
                                <br />
                                <Table responsive className="attachmentTable" id="tbl_PM_Attachments">
                                    <tbody>
                                        <tr><th width="90%">ATTACHMENTS</th><th width="10%">{" "}</th></tr>
                                        {Attachment_Table}
                                        {(this.state.displayImageError) ? error_record : null}
                                    </tbody>
                                </Table>
                                <Label className="workorderlbl-noentry">{label['WorkOrderEdit.FileTypes.Text']}</Label>
                            </div></div>
                        
                        </div>
                    </div>
                    <br />
                    <div>
                        <Button className="wo_cancel_btn" id="btn_PM_Cancel" style={{ 'float': 'right', 'margin-left': '6px', 'margin-right': '0px' }} onClick={this.OnCancel}>{label['PreventativeMaintenance.Button.Cancel.Text']}</Button>
                        <Button className="wo_save_btn" id="btn_PM_Save" style={{ 'float': 'right', 'margin-right': '0px' }} onClick={this.OnSavePreventativeMaintenance} disabled={this.state.IsClickSave} > {label['WorkOrders.Button.Create.Text']}</Button>
                    </div>
                    </div>
                }
                <SearchableEquipmentDropDown name="Equipmentdropdown" refMethod={this.setEquipmentWrapperRef} groupname="rdEquipment" data={this.state.EquipmentData} selectedID={this.state.EquipmentId} selectedLocation={this.state.EquipmentLocation} elementStyle={this.state.EquipmentDropDownStyles} setValue={this.setEquipment} />
                <Modal zIndex={this.props.ForEquipment ? 2147483646 : 1050} isOpen={this.state.Schedulemodal} id="PM_Recurence_Modal" className={classnames({ classnames: this.props.className }, "ModalContainer short_modal")} >
                    <div style={{ "margin-left": "10px", "margin-bottom": "-13px" }}>
                        <Label className='workordermainheaderlbl' style={{ paddingTop: '8px' }}>{label['CreatePM.MaintenanceSchedule.Text'] !== undefined ? label['CreatePM.MaintenanceSchedule.Text'] : "Maintenance Schedule"}</Label>
                        <div style={{ valign: 'bottom', 'float': 'right', padding: '8px' }} className="PM_Close_Icon" onClick={this.Scheduletoggle}><IoMdClose /></div>
                    </div>
                    <Form style={{ 'overflow': 'visible' }}>
                        <FormGroup row style={{ "margin-bottom": "1px", "margin-right": "0px", "margin-left": "0px" }}>
                            <Col sm={{ size: 12 }} style={{ "padding-left": "0px", "padding-right": "0px" }}>
                                <hr style={{ backgroundColor: '1px solid #CCCCCC' }} />
                            </Col>
                        </FormGroup>
                        <div className="Recurrendiv_Content">
                            <FormGroup row style={{ 'margin-top': '17px' }}>
                                <Col sm={{ size: 12 }} style={{ 'margin-left': '15px' }}>
                                    <Label className='Recurrendiv_Label'>{label['CreatePM.Recurrence.Text'] !== undefined ? label['CreatePM.Recurrence.Text'] : "Recurrence*"}</Label>
                                    <br />
                                    <Label className="Recurrendiv_Label"><input id="am_rdl_usage" type="radio" ref="rdl_Usage" defaultChecked={HasUsageSelected} name="ScheduleType" className="pm_regular_radiobtn" onChange={this.ScheduleTypeChange} />&nbsp;{label['CreatePM.Usage.Text'] !== undefined ? label['CreatePM.Usage.Text'] : "Based on usage"}</Label>
                                    <Label className="Recurrendiv_Label" style={{ 'margin-left': '10px' }}><input id="am_rdl_calendar" type="radio" defaultChecked={!HasUsageSelected} ref="rdl_Calendar" name="ScheduleType" className="pm_regular_radiobtn" onChange={this.ScheduleTypeChange} />&nbsp;{label['CreatePM.Calendar.Text'] !== undefined ? label['CreatePM.Calendar.Text'] : "Based on calendar"}</Label>
                                </Col>
                            </FormGroup>
                            <div style={{ "display": (this.state.ScheduleTypeRdl === 1 || this.state.ScheduleTypeRdl === 0) ? "block" : "none" }}>
                                <FormGroup row>
                                    <Col sm={{ size: 6 }} style={{ 'margin-left': '15px' }}>
                                        <Label className='Recurrendiv_Label' style={{ 'margin-bottom': '0px' }}>{label['CreatePM.DueDate.Text'] !== undefined ? label['CreatePM.DueDate.Text'] : "Due Date*"}</Label>
                                        <br />
                                        <label style={{ 'cursor': 'pointer' }}>
                                            <DatePicker id="dp_Due_date" selected={this.state.RecurrenceDueDate} minDate={(this.state.BuildingId > 0) ? this.state.SelectedBuildingDate : ServerDateTime} onChange={this.handleChange} className={(this.state.DueDateError) ? "workorderedit-dropdown pm_bg_color Pm_Full_Width errorhighlight" : "workorderedit-dropdown pm_bg_color Pm_Full_Width"} />
                                            <div className="pm_calendardiv">
                                                <FaRegCalendarAlt className="pm_calendarbox" />
                                            </div>
                                        </label>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Col sm={{ size: 12 }} style={{ 'margin-left': '15px' }}>
                                        <Label className='Recurrendiv_Label' style={{ 'margin-bottom': '0px' }}>{label['CreatePM.RepeatEvery.Text'] !== undefined ? label['CreatePM.RepeatEvery.Text'] : "Repeat every*"}</Label>
                                        <br />
                                        <input id="am_txtmodifier" type="text" ref='modifier_in_input' defaultValue={this.state.RepeatEvery} style={{ width: '30%' }} className={(this.state.RepeatEveryError) ? "pm_textbox errorhighlight" : "pm_textbox"} onChange={evt => this.OnCalendarLimitChange(evt)} />
                                        <select ref='interval_in_Select_input' id="am_ddl_interval" className="minimal workorderedit-dropdown" style={{ width: '50%', "margin-left": "8px" }} onChange={this.OnIntervalChange} >
                                            {interval_in_Select_input}
                                        </select>
                                    </Col>
                                </FormGroup>
                            </div>
                            <div style={{ "display": this.state.ScheduleTypeRdl === 2 ? "block" : "none" }}>
                                <FormGroup row>
                                    <Col sm={{ size: 10 }} style={{ 'margin-left': '15px' }}>
                                        <Label className={(this.state.UsageError.building) ? "errortext workorderlbl UsageCreatePMlbl_margin" : "workorderlbl UsageCreatePMlbl_margin"}>Building*</Label><br />
                                        <select id="am_ddl_usagebuilding" ref='usage_building_in_Select_input' selectedValue={this.state.UsageBuildingName} className={(this.state.UsageError.building) ? "errorhighlight minimal workorderedit-dropdown" : "minimal workorderedit-dropdown"} style={{ width: '100%', "color": this.state.UsageBuildingId !== '0' ? '#000000' : '#999999' }} onChange={this.OnUsageBuildingChange} >
                                            {this.props.ForEquipment ? Default_drop_down_value_Unselected : Default_drop_down_value}
                                            {usage_buildings_in_Select_input}
                                        </select>
                                        <span hidden={!this.state.UsageError.building}>{selecterrortext}</span>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Col sm={{ size: 10 }} style={{ 'margin-left': '15px' }}>
                                        <Label className={(this.state.UsageError.Family) ? "errortext workorderlbl UsageCreatePMlbl_margin" : "workorderlbl UsageCreatePMlbl_margin"}>Family Type*</Label><br />
                                        <select id="am_ddl_usagefamily" ref='usage_family_in_Select_input' selectedValue={this.state.FamilyText} className={(this.state.UsageError.Family) ? "errorhighlight minimal workorderedit-dropdown" : "minimal workorderedit-dropdown"} style={{ width: '100%', "color": this.state.UsageFamilyTypeId !== '0' ? '#000000' : '#999999' }} onChange={this.OnUsageFamilyTypeChange} >
                                            {this.props.ForEquipment ? Default_drop_down_value_Unselected : Default_drop_down_value}
                                            {usage_familytype_in_Select_input}
                                        </select>
                                        <span hidden={!this.state.UsageError.Family}>{selecterrortext}</span>
                                    </Col>
                                </FormGroup>
                                <FormGroup row style={{ "display": this.state.UsageFamilyTypeId != '7' ? "block" : "none" }}>
                                    <Col sm={{ size: 10 }} style={{ 'margin-left': '15px' }}>
                                        <Label className={(this.state.UsageError.Equipment) ? "errortext workorderlbl UsageCreatePMlbl_margin" : "workorderlbl UsageCreatePMlbl_margin"}>Equipment*</Label><br />
                                        <select id="am_ddl_usageequipment" ref='usage_equipment_in_Select_input' selectedValue={this.state.EquipmentText} className={(this.state.UsageError.Equipment) ? "errorhighlight minimal workorderedit-dropdown" : "minimal workorderedit-dropdown"} style={{ width: '100%', "color": this.state.UsageEquipmentId !== '0' ? '#000000' : '#999999', "display": this.state.UsageFamilyTypeId !== '7' ? "block" : "none" }} onChange={this.OnUsageEquipmentChange} >
                                            {this.props.ForEquipment ? Default_drop_down_value_Unselected : Default_drop_down_value}
                                            {usage_equipment_in_Select_input}
                                        </select>
                                        <span hidden={!this.state.UsageError.Equipment}>{selecterrortext}</span>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Col sm={{ size: 10 }} style={{ 'margin-left': '15px' }}>
                                        <Label className={(this.state.UsageError.Point) ? "errortext workorderlbl UsageCreatePMlbl_margin" : "workorderlbl UsageCreatePMlbl_margin"}>Points*</Label><br />
                                        <select id="am_ddl_usagepoints" ref='usage_points_in_Select_input' className={(this.state.UsageError.Point) ? "errorhighlight minimal workorderedit-dropdown" : "minimal workorderedit-dropdown"} style={{ width: '100%', "color": this.state.UsagePointId !== '0' ? '#000000' : '#999999' }} onChange={this.OnUsagePointsChange} >
                                            {Default_drop_down_value}
                                            {usage_point_in_Select_input}
                                        </select>
                                        <span hidden={!this.state.UsageError.Point}>{selecterrortext}</span>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Col sm={{ size: 10 }} style={{ 'margin-left': '15px' }}>
                                        <Label className={(this.state.UsageError.limit) ? "errortext workorderlbl UsageCreatePMlbl_margin" : "workorderlbl UsageCreatePMlbl_margin"}>Interval*</Label><br />
                                        <input type="text" id="am_ddl_usageparameter" ref='usage_parameter_in_input' style={{ width: '70%' }} className={(this.state.UsageError.limit) ? "errorhighlight pm_textbox" : "pm_textbox"} defaultValue={this.state.LimitValue} onChange={evt => this.OnLimitChange(evt)} />
                                        <Label className="workorderlbl CreatePMlbl_margin" style={{ 'padding-left': '10px' }}>{this.state.UnitName}</Label>
                                    </Col>
                                </FormGroup>
                            </div>
                            <FormGroup row>
                                <Col sm={{ size: 8 }} style={{ 'margin-left': '15px' }}>
                                    <Label className="workorderlbl-noentry">{this.state.SchduleTypeText}</Label>
                                </Col>
                            </FormGroup>
                        </div>
                        <FormGroup row style={{ "margin-bottom": "0px", "margin-right": "0px", "margin-left": "0px" }}>
                            <Col sm={{ size: 12 }} style={{ "padding-left": "0px", "padding-right": "0px" }}>
                                <hr style={{ backgroundColor: '1px solid #CCCCCC', "margin-bottom": "4px" }} />
                                <Label className='Pm_RecurrenceRequiredText' style={{ "margin-left": "10px" }}>{"* required fields"}</Label>
                            </Col>
                        </FormGroup>
                    </Form>
                    <div style={{ "margin-right": "10px", "margin-bottom": "4px" }}>
                        <Button id="am_btn_schedulecancel" className="wo_cancel_btn" style={{ 'float': 'right', 'margin-left': '6px' }} onClick={this.OnCancelRecurrencePattern}>{label['PreventativeMaintenance.Button.Cancel.Text']}</Button>
                        <Button id="am_btn_schedulesave" className="wo_save_btn" style={{ 'float': 'right' }} onClick={this.OnSaveRecurrencePattern} disabled={this.state.IsClickSave} > {label['PreventativeMaintenance.Button.Save.Text']}</Button>
                    </div>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getWorkOrderBuildings: state.WorkorderRootReducer.WorkorderBuildings,
        getTechnicianList: state.WorkorderRootReducer.Technicians,
        getBuildingEquipments: state.WorkorderRootReducer.PMBuildingsEquipments,
        getPreferences: state.authService.preventative_maintenance_user_preferencedetails,
        getFamilyTypes: state.WorkorderRootReducer.BuildingFamilyTypes,
        getEquipmentsByFamily: state.WorkorderRootReducer.BuildingEquipmentsByFamilyType,
        getBuildingEquipmentPoints: state.WorkorderRootReducer.BuildingEquipmentPoints,
        getBuildingPoints: state.WorkorderRootReducer.BuildingPoints,
        getUsageFamilyTypes: state.WorkorderRootReducer.UsageBuildingFamilyTypes,
        getUsageEquipmentsByFamily: state.WorkorderRootReducer.UsageBuildingEquipmentsByFamilyType,
        getServerTime: state.WorkorderRootReducer.ServerTime,
        getEquipments: state.WorkorderRootReducer.WorkorderEquipments,
        getCustomFields: state.WorkorderRootReducer.PreventativeMaintenanceCustomFields,
        getMailSetting: state.WorkorderRootReducer.MailSetting,
        getTemplates: state.WorkorderRootReducer.PreventativeMaintenanceTemplates,
        getUniqueAttachmentName: state.WorkorderRootReducer.UniqueAttachmentName,
        getUniqueAttachmentCollection: state.WorkorderRootReducer.UniqueAttachmentCollection,
        AddTemplateModal: state.WorkorderRootReducer.AddTemplateModalOpenClose
    };
};


const mapDispatchToProps = dispatch => {
    return {
        GetWorkOrderBuildingsList: () => dispatch(GetWorkOrderBuildingsList()),
        GetPMBuildingsEquipments: (BuildingId) => dispatch(GetPMBuildingsEquipments(BuildingId)),
        GetWorkorderTechnician: () => dispatch(GetWorkorderTechnician()),
        DeleteAttachment: (lineitem) => dispatch(DeleteAttachment(lineitem)),
        SavePreventativeMaintenance: (data, id) => dispatch(SavePreventativeMaintenance(data, id)),
        GetFamilyTypesBySiteId: (id) => dispatch(GetFamilyTypesBySiteId(id)),
        GetUsageFamilyTypesBySiteId: (id) => dispatch(GetUsageFamilyTypesBySiteId(id)),
        GetEquipmentsByFamilyType: (siteId, id) => dispatch(GetEquipmentsByFamilyType(siteId, id)),
        GetUsageEquipmentsByFamilyType: (siteId, id) => dispatch(GetUsageEquipmentsByFamilyType(siteId, id)),
        GetBuildingPoints: (siteId) => dispatch(GetBuildingPoints(siteId)),
        GetBuildingEquipmentPoints: (siteId, equipId) => dispatch(GetBuildingEquipmentPoints(siteId, equipId)),
        GetServerTime: () => dispatch(GetServerTime()),
        GetWorkOrderEquipments: () => dispatch(GetWorkOrderEquipments()),
        GetPMCustomFields: () => dispatch(GetPreventativeMaintenanceCustomFields()),
        GetPreventativeMaintenanceTemplates: () => dispatch(GetPreventativeMaintenanceTemplates()),
        SaveAttachmentToFolder: (file, AttachmentId) => dispatch(SaveAttachmentToFolder(file, AttachmentId)),
        SaveAsAttachment: (data) => dispatch(SaveAsAttachment(data)),
        OpenAddTemplatePopup: (data, templateId) => dispatch(OpenAddTemplatePopup(data, templateId)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreatePreventativeMaintenance);